<template>
  <div id="section-to-print">
    <!-- /////////////////////////////////START OF DIREKSI//////////////////////////////////////////// -->
    <div class="row add-page-break-after">
      <div class="col-12">
        <div class="p-3 mb-3">
          <div class="row">
            <div class="col-12">
              <h5
                style="
                  font-weight: bold;
                  font-family: Arial, sans-serif;
                  font-size: 12px;
                "
              >
                PERUSAHAAN UMUM DAERAH AIR MINUM
              </h5>
              <h5
                style="
                  font-weight: bold;
                  font-family: Arial, sans-serif;
                  font-size: 12px;
                "
              >
                TIRTA HITA BULELENG
              </h5>
              <h4 class="header-title">
                <strong>DAFTAR PEMBAYARAN GAJI DIREKSI </strong>
              </h4>
              <h5 class="header-periode" style="padding-bottom: 20px">
                <strong
                  >UNTUK BULAN: {{ printBulanNama() }}
                  {{ printTahun() }}</strong
                >
              </h5>
              <table class="table" v-if="gajisDireksi">
                <thead>
                  <tr class="center-top-text">
                    <th rowspan="3">NO</th>
                    <th rowspan="3" style="min-width: 120px">
                      NAMA<br />
                      <br />NIP/NIK<br />JABATAN
                    </th>
                    <th rowspan="3" colspan="2" style="width: 3%">GOL.</th>
                    <th rowspan="2">GAJI</th>
                    <th colspan="9" rowspan="1">TUNJANGAN</th>
                    <th colspan="2" rowspan="1">POT. KETIDAKHADIRAN</th>
                    <th rowspan="2">
                      JUMLAH<br />
                      BRUTO
                    </th>
                    <th rowspan="2">TUNJANGAN<br />PPH</th>
                    <th rowspan="2">JUMLAH<br />(15+16)</th>
                    <th rowspan="1" colspan="6">POTONGAN</th>
                    <th rowspan="2">JUMLAH<br />DITERIMA</th>
                    <th rowspan="3" style="width: 2%" class="no-right-border">
                      &nbsp;
                    </th>
                    <th rowspan="3">TANDA TANGAN</th>
                  </tr>

                  <tr class="center-top-text">
                    <th style="width: 5%">
                      PERUSAHAAN
                      <div class="small-text">(5)x 25%</div>
                    </th>
                    <th>JABATAN</th>
                    <th>
                      KEMAHALAN
                      <div class="small-text">(5)x 5%</div>
                    </th>
                    <th>AIR</th>
                    <th>TRANSPORT</th>
                    <th>PANGAN</th>
                    <th>KESEHATAN</th>
                    <th>PREMI JKK</th>
                    <th>PREMI JKM</th>

                    <th>HARI</th>
                    <th>
                      JUMLAH
                      <div class="small-text">13X5%(6+10)</div>
                    </th>
                    <th>KESEHATAN</th>
                    <th>
                      BPJS TK<br />3 PROGRAM
                      <div class="small-text">(15)X2%</div>
                    </th>
                    <th>
                      BPJS TK<br />4 PROGRAM
                      <div class="small-text">(Bts maxX1% JP)+<br />2% JHT</div>
                    </th>
                    <th>PENSIUN<br />IFG LIFE</th>
                    <th>IFG<br />MANDIRI</th>
                    <th>PPH<br />PASAL 21</th>
                  </tr>

                  <tr class="center-top-text">
                    <th style="border: none">(Rp.)</th>
                    <th>(Rp.)</th>
                    <th>(Rp.)</th>
                    <th>(Rp.)</th>
                    <th>(Rp.)</th>
                    <th>(Rp.)</th>
                    <th>(Rp.)</th>
                    <th>(Rp.)</th>
                    <th>(Rp.)</th>
                    <th>(Rp.)</th>
                    <th></th>
                    <th>(Rp.)</th>
                    <th>(Rp.)</th>
                    <th>(Rp.)</th>
                    <th>(Rp.)</th>
                    <th>(Rp.)</th>
                    <th>(Rp.)</th>
                    <th>(Rp.)</th>
                    <th>(Rp.)</th>
                    <th>(Rp.)</th>
                    <th>(Rp.)</th>
                    <th>(Rp.)</th>
                  </tr>
                  <tr class="center-top-text">
                    <th>1</th>
                    <th>2</th>
                    <th>3</th>
                    <th>4</th>
                    <th>5</th>
                    <th>6</th>
                    <th>7</th>
                    <th>8</th>
                    <th>9</th>
                    <th>10</th>
                    <th>11</th>
                    <th>12</th>
                    <th>13</th>
                    <th>14</th>
                    <th>15</th>
                    <th>16</th>
                    <th>17</th>
                    <th>18</th>
                    <th>19</th>
                    <th>20</th>
                    <th>21</th>
                    <th>22</th>
                    <th>23</th>
                    <th>24</th>
                    <th>25</th>
                    <th>26</th>
                    <th></th>
                    <th>27</th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="(item, index) in gajisDireksi.gajis"
                    :key="item.id"
                    :class="getPageBreakStyle(index)"
                  >
                    <td style="border: 1px solid #000">
                      {{ index + 1 }}
                    </td>
                    <td style="border: 1px solid #000; min-width: 120px">
                      {{ item.pegawai.nama }}<br />NIK.
                      {{ item.pegawai.nik }}
                    </td>
                    <td style="border: 1px solid #000">
                      {{ item.golongan.nama }}
                    </td>

                    <td style="border: 1px solid #000">
                      {{ item.pph ? item.pph.ptkp : "" }}
                      <!-- {{ item.pegawai.status_ptkp }} -->
                    </td>

                    <td style="border: 1px solid #000">
                      {{ formatNumber(item.gaji_pokok) }}
                    </td>

                    <td style="border: 1px solid #000">
                      {{ formatNumber(item.tun_perusahaan) }}
                    </td>

                    <td style="border: 1px solid #000">
                      {{ formatNumber(item.tun_jabatan) }}
                    </td>

                    <td style="border: 1px solid #000">
                      {{ formatNumber(item.tun_kemahalan) }}
                    </td>

                    <td style="border: 1px solid #000">
                      {{ formatNumber(item.tun_air) }}
                    </td>

                    <td style="border: 1px solid #000">
                      {{ formatNumber(item.tun_transport) }}
                    </td>

                    <td style="border: 1px solid #000">
                      {{ formatNumber(item.tun_pangan) }}
                    </td>

                    <td style="border: 1px solid #000">
                      {{ formatNumber(item.tun_kesehatan) }}
                    </td>
                    <td style="border: 1px solid #000">
                      {{ formatNumber(item.premi_jkk) }}
                    </td>
                    <td style="border: 1px solid #000">
                      {{ formatNumber(item.premi_jkm) }}
                    </td>

                    <td style="border: 1px solid #000">
                      {{ formatNumber(item.jml_tdk_hadir) }}
                    </td>

                    <td style="border: 1px solid #000">
                      {{ formatNumber(item.pot_5_persen) }}
                    </td>

                    <td style="border: 1px solid #000">
                      {{ formatNumber(item.jml_bruto) }}
                    </td>

                    <td style="border: 1px solid #000">
                      {{ formatNumber(item.tun_pph) }}
                    </td>
                    <td style="border: 1px solid #000">
                      {{ formatNumber(item.pot_5_persen + item.jml_bruto) }}
                    </td>
                    <td style="border: 1px solid #000">
                      {{ formatNumber(item.pot_kesehatan) }}
                    </td>
                    <td style="border: 1px solid #000">
                      {{ formatNumber(item.pot_bpjs_tk_tiga_program) }}
                    </td>
                    <td style="border: 1px solid #000">
                      {{ formatNumber(item.pot_bpjs_tk_empat_program) }}
                    </td>
                    <td style="border: 1px solid #000">
                      {{ formatNumber(item.pot_pensiun) }}
                    </td>
                    <td style="border: 1px solid #000">
                      {{ formatNumber(item.ifg_mandiri) }}
                    </td>
                    <td style="border: 1px solid #000">
                      {{ formatNumber(item.pot_pph) }}
                    </td>
                    <td style="border: 1px solid #000">
                      {{ formatNumber(item.total_diterima) }}
                    </td>
                    <td style="border: 1px solid #000" class="bottom-text">
                      {{ index + 1 }}
                    </td>
                    <td class="bottom-text">...............</td>
                  </tr>
                </tbody>
                <tr
                  class="top-text table-row-vfor"
                  v-if="gajisDireksi.totalGajis"
                >
                  <td style="border: 1px solid #000; font-weight: bold"></td>
                  <td style="border: 1px solid #000; font-weight: bold">
                    JUMLAH
                  </td>
                  <td style="border: 1px solid #000; font-weight: bold"></td>
                  <td style="border: 1px solid #000; font-weight: bold"></td>

                  <td style="border: 1px solid #000; font-weight: bold">
                    {{ formatNumber(gajisDireksi.totalGajis.gaji_pokok) }}
                  </td>

                  <td style="border: 1px solid #000; font-weight: bold">
                    {{ formatNumber(gajisDireksi.totalGajis.tun_perusahaan) }}
                  </td>

                  <td style="border: 1px solid #000; font-weight: bold">
                    {{ formatNumber(gajisDireksi.totalGajis.tun_jabatan) }}
                  </td>

                  <td style="border: 1px solid #000; font-weight: bold">
                    {{ formatNumber(gajisDireksi.totalGajis.tun_kemahalan) }}
                  </td>

                  <td style="border: 1px solid #000; font-weight: bold">
                    {{ formatNumber(gajisDireksi.totalGajis.tun_air) }}
                  </td>

                  <td style="border: 1px solid #000; font-weight: bold">
                    {{ formatNumber(gajisDireksi.totalGajis.tun_transport) }}
                  </td>

                  <td style="border: 1px solid #000; font-weight: bold">
                    {{ formatNumber(gajisDireksi.totalGajis.tun_pangan) }}
                  </td>

                  <td style="border: 1px solid #000; font-weight: bold">
                    {{ formatNumber(gajisDireksi.totalGajis.tun_kesehatan) }}
                  </td>
                  <td style="border: 1px solid #000; font-weight: bold">
                    {{ formatNumber(gajisDireksi.totalGajis.premi_jkk) || 0 }}
                  </td>
                  <td style="border: 1px solid #000; font-weight: bold">
                    {{ formatNumber(gajisDireksi.totalGajis.premi_jkm) || 0 }}
                  </td>

                  <td style="border: 1px solid #000; font-weight: bold">
                    {{ formatNumber(gajisDireksi.totalGajis.jml_tdk_hadir) }}
                  </td>

                  <td style="border: 1px solid #000; font-weight: bold">
                    {{ formatNumber(gajisDireksi.totalGajis.pot_5_persen) }}
                  </td>

                  <td style="border: 1px solid #000; font-weight: bold">
                    {{ formatNumber(gajisDireksi.totalGajis.jml_bruto) }}
                  </td>

                  <td style="border: 1px solid #000; font-weight: bold">
                    {{ formatNumber(gajisDireksi.totalGajis.tun_pph) }}
                  </td>
                  <td style="border: 1px solid #000; font-weight: bold">
                    {{
                      formatNumber(
                        gajisDireksi.totalGajis.tun_pph +
                          gajisDireksi.totalGajis.jml_bruto,
                      )
                    }}
                  </td>
                  <td style="border: 1px solid #000; font-weight: bold">
                    {{ formatNumber(gajisDireksi.totalGajis.pot_kesehatan) }}
                  </td>
                  <td style="border: 1px solid #000; font-weight: bold">
                    {{
                      formatNumber(
                        gajisDireksi.totalGajis.pot_bpjs_tk_tiga_program,
                      )
                    }}
                  </td>
                  <td style="border: 1px solid #000; font-weight: bold">
                    {{
                      formatNumber(
                        gajisDireksi.totalGajis.pot_bpjs_tk_empat_program,
                      )
                    }}
                  </td>
                  <td style="border: 1px solid #000; font-weight: bold">
                    {{ formatNumber(gajisDireksi.totalGajis.pot_pensiun) }}
                  </td>
                  <td style="border: 1px solid #000; font-weight: bold">
                    {{ formatNumber(gajisDireksi.totalGajis.ifg_mandiri) || 0 }}
                  </td>

                  <td style="border: 1px solid #000; font-weight: bold">
                    {{ formatNumber(gajisDireksi.totalGajis.pot_pph) }}
                  </td>
                  <td style="border: 1px solid #000; font-weight: bold">
                    {{ formatNumber(gajisDireksi.totalGajis.total_diterima) }}
                  </td>
                  <td
                    style="border: 1px solid #000; font-weight: bold"
                    class="bottom-text"
                  ></td>
                  <td class="bottom-text"></td>
                </tr>
                <!-- <tr></tr> -->
              </table>
              <div class="row arial12" v-if="gajisDireksi">
                <div class="col-12">
                  <p>
                    Terbilang : -----
                    {{
                      formatNumberTerbilang(
                        gajisDireksi.totalGajis.tun_pph +
                          gajisDireksi.totalGajis.jml_bruto,
                      )
                    }}
                    Rupiah -----
                  </p>
                </div>
                <div class="row" style="text-align: center">
                  <div class="col-4">
                    Perumda Air Minum <br />
                    Tirta Hita Buleleng <br />
                    Mengetahui: <br />
                    <br />

                    <div
                      style="text-decoration: underline; padding-top: 35px"
                      v-if="pejabat.dirum"
                    >
                      {{ pejabat.dirum.nama }}
                    </div>

                    Direktur Umum
                  </div>
                  <div class="col-4">
                    <br />
                    <br />

                    Diperiksa:<br />
                    <br />

                    <div
                      style="text-decoration: underline; padding-top: 35px"
                      v-if="pejabat.pejabatMengetahui"
                    >
                      {{ pejabat.pejabatMengetahui.nama }}
                    </div>
                    <div v-if="pejabat.pejabatMengetahui">
                      {{ pejabat.pejabatMengetahui.jabatan }}
                    </div>
                  </div>
                  <div class="col-4">
                    <br />

                    Singaraja,
                    {{ this.pejabatMembuatTgl }}
                    <br />

                    Dibuat Oleh:<br />
                    <br />

                    <div
                      style="text-decoration: underline; padding-top: 35px"
                      v-if="pejabat.pejabatMembuat"
                    >
                      {{ pejabat.pejabatMembuat.nama }}
                    </div>
                    <div v-if="pejabat.pejabatMembuat">
                      {{ pejabat.pejabatMembuat.jabatan }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- /col-12 -->
    </div>
    <!-- /row add-page-break-after  END OF GAJI DIREKSI-->

    <!-- /////////////////////////////////START OF TETAP//////////////////////////////////////////// -->

    <div v-for="cabang in cabangs" :key="cabang.id">
      <!-- Render this div if cabang.id is equal to 1 -->
      <div v-if="cabang.id === 1">
        <!-- Content for cabang with id 1 -->
        <!-- iteration bagians -->
        <div v-for="bagian in bagians" :key="bagian.id">
          <div class="row add-page-break-after">
            <div class="col-12">
              <div class="p-3 mb-3">
                <div class="row">
                  <div class="col-12">
                    <h5
                      style="
                        font-weight: bold;
                        font-family: Arial, sans-serif;
                        font-size: 12px;
                      "
                    >
                      PERUSAHAAN UMUM DAERAH AIR MINUM
                    </h5>
                    <h5
                      style="
                        font-weight: bold;
                        font-family: Arial, sans-serif;
                        font-size: 12px;
                      "
                    >
                      TIRTA HITA BULELENG
                    </h5>
                    <h4 class="header-title">
                      <strong
                        >DAFTAR PEMBAYARAN GAJI BAGIAN
                        {{ toUpper(bagian.nama) }}
                      </strong>
                    </h4>
                    <h5 class="header-periode" style="padding-bottom: 20px">
                      <strong
                        >UNTUK BULAN: {{ printBulanNama() }}
                        {{ printTahun() }}</strong
                      >
                    </h5>

                    <table class="table" v-if="gajis">
                      <thead>
                        <tr class="center-top-text">
                          <th rowspan="3">NO</th>
                          <th rowspan="3" style="min-width: 120px">
                            NAMA<br />
                            <br />NIP/NIK<br />JABATAN
                          </th>
                          <th rowspan="3" colspan="2" style="width: 3%">
                            GOL.
                          </th>
                          <th rowspan="2">GAJI<br />POKOK</th>
                          <th colspan="9" rowspan="1">TUNJANGAN</th>
                          <th colspan="2" rowspan="1">POT. KETIDAKHADIRAN</th>
                          <th rowspan="2">
                            JUMLAH<br />
                            BRUTO
                          </th>
                          <th rowspan="2">TUNJANGAN<br />PPH</th>
                          <th rowspan="2">JUMLAH<br />(15+16)</th>
                          <th rowspan="1" colspan="6">POTONGAN</th>
                          <th rowspan="2">JUMLAH<br />DITERIMA</th>
                          <th
                            rowspan="3"
                            style="width: 2%"
                            class="no-right-border"
                          >
                            &nbsp;
                          </th>
                          <th rowspan="3">TANDA TANGAN</th>
                        </tr>

                        <tr class="center-top-text">
                          <th style="width: 5%">
                            PERUSAHAAN
                            <div class="small-text">(5)x 25%</div>
                          </th>
                          <th>JABATAN</th>
                          <th>
                            KEMAHALAN
                            <div class="small-text">(5)x 5%</div>
                          </th>
                          <th>AIR</th>
                          <th>TRANSPORT</th>
                          <th>PANGAN</th>
                          <th>KESEHATAN</th>
                          <th>PREMI JKK</th>
                          <th>PREMI JKM</th>
                          <th>HARI</th>
                          <th>
                            JUMLAH
                            <div class="small-text">13X5%(6+10)</div>
                          </th>
                          <th>KESEHATAN</th>
                          <th>
                            BPJS TK<br />3 PROGRAM
                            <div class="small-text">(15)X2%</div>
                          </th>
                          <th>
                            BPJS TK<br />4 PROGRAM
                            <div class="small-text">(15)X3%</div>
                          </th>
                          <th>PENSIUN<br />IFG LIFE</th>
                          <th>IFG<br />MANDIRI</th>
                          <th>PPH<br />PASAL 21</th>
                        </tr>

                        <tr class="center-top-text">
                          <th style="border: none">(Rp.)</th>
                          <th>(Rp.)</th>
                          <th>(Rp.)</th>
                          <th>(Rp.)</th>
                          <th>(Rp.)</th>
                          <th>(Rp.)</th>
                          <th>(Rp.)</th>
                          <th>(Rp.)</th>
                          <th>(Rp.)</th>
                          <th>(Rp.)</th>
                          <th></th>
                          <th>(Rp.)</th>
                          <th>(Rp.)</th>
                          <th>(Rp.)</th>
                          <th>(Rp.)</th>
                          <th>(Rp.)</th>
                          <th>(Rp.)</th>
                          <th>(Rp.)</th>
                          <th>(Rp.)</th>
                          <th>(Rp.)</th>
                          <th>(Rp.)</th>
                          <th>(Rp.)</th>
                        </tr>
                        <tr class="center-top-text">
                          <th>1</th>
                          <th>2</th>
                          <th>3</th>
                          <th>4</th>
                          <th>5</th>
                          <th>6</th>
                          <th>7</th>
                          <th>8</th>
                          <th>9</th>
                          <th>10</th>
                          <th>11</th>
                          <th>12</th>
                          <th>13</th>
                          <th>14</th>
                          <th>15</th>
                          <th>16</th>
                          <th>17</th>
                          <th>18</th>
                          <th>19</th>
                          <th>20</th>
                          <th>21</th>
                          <th>22</th>
                          <th>23</th>
                          <th>24</th>
                          <th>25</th>
                          <th>26</th>
                          <th></th>
                          <th>27</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr
                          v-for="(item, index) in filterGajisByConditions(
                            [
                              {
                                indexs: ['riwayat_pekerjaan', 'cabang_id'],
                                val: cabang.id,
                              },
                              {
                                indexs: ['riwayat_pekerjaan', 'bagian_id'],
                                val: bagian.id,
                              },
                            ],
                            'sub_bagian_id',
                            'gajis',
                          )"
                          :key="item.id"
                          :class="getPageBreakStyle(index)"
                        >
                          <td style="border: 1px solid #000">
                            <span
                              :style="printNewLine(item.print_sub_bagian)"
                              v-if="subBagians"
                            >
                            </span>
                            {{ index + 1 }}
                          </td>
                          <td style="border: 1px solid #000">
                            <div :style="boldStyle">
                              <!-- v-if="shouldRenderSubBagian" -->
                              {{
                                printSubBagian(
                                  item.print_sub_bagian,
                                  item.riwayat_pekerjaan,
                                )
                              }}
                            </div>
                            {{ item.pegawai.nama }}
                            <br />NIK.
                            {{ item.pegawai.nik }}
                          </td>
                          <td style="border: 1px solid #000">
                            <span :style="printNewLine(item.print_sub_bagian)">
                            </span>
                            {{ item.golongan.nama }}
                          </td>

                          <td style="border: 1px solid #000">
                            <span :style="printNewLine(item.print_sub_bagian)">
                            </span>
                            <!-- {{ item.pegawai.status_ptkp }} -->
                            {{ item.pph ? item.pph.ptkp : "" }}
                          </td>

                          <td style="border: 1px solid #000">
                            <span :style="printNewLine(item.print_sub_bagian)">
                            </span>
                            {{ formatNumber(item.gaji_pokok) }}
                          </td>

                          <td style="border: 1px solid #000">
                            <span :style="printNewLine(item.print_sub_bagian)">
                            </span>
                            {{ formatNumber(item.tun_perusahaan) }}
                          </td>

                          <td style="border: 1px solid #000">
                            <span :style="printNewLine(item.print_sub_bagian)">
                            </span>
                            {{ formatNumber(item.tun_jabatan) }}
                          </td>

                          <td style="border: 1px solid #000">
                            <span :style="printNewLine(item.print_sub_bagian)">
                            </span>
                            {{ formatNumber(item.tun_kemahalan) }}
                          </td>

                          <td style="border: 1px solid #000">
                            <span :style="printNewLine(item.print_sub_bagian)">
                            </span>
                            {{ formatNumber(item.tun_air) }}
                          </td>

                          <td style="border: 1px solid #000">
                            <span :style="printNewLine(item.print_sub_bagian)">
                            </span>
                            {{ formatNumber(item.tun_transport) }}
                          </td>

                          <td style="border: 1px solid #000">
                            <span :style="printNewLine(item.print_sub_bagian)">
                            </span>
                            {{ formatNumber(item.tun_pangan) }}
                          </td>

                          <td style="border: 1px solid #000">
                            <span :style="printNewLine(item.print_sub_bagian)">
                            </span>
                            {{ formatNumber(item.tun_kesehatan) }}
                          </td>
                          <td style="border: 1px solid #000">
                            <span :style="printNewLine(item.print_sub_bagian)">
                            </span>
                            {{ formatNumber(item.premi_jkk) }}
                          </td>
                          <td style="border: 1px solid #000">
                            <span :style="printNewLine(item.print_sub_bagian)">
                            </span>
                            {{ formatNumber(item.premi_jkm) }}
                          </td>

                          <td style="border: 1px solid #000">
                            <span :style="printNewLine(item.print_sub_bagian)">
                            </span>
                            {{ formatNumber(item.jml_tdk_hadir) }}
                          </td>

                          <td style="border: 1px solid #000">
                            <span :style="printNewLine(item.print_sub_bagian)">
                            </span>
                            {{ formatNumber(item.pot_5_persen) }}
                          </td>

                          <td style="border: 1px solid #000">
                            <span :style="printNewLine(item.print_sub_bagian)">
                            </span>
                            {{ formatNumber(item.jml_bruto) }}
                          </td>

                          <td style="border: 1px solid #000">
                            <span :style="printNewLine(item.print_sub_bagian)">
                            </span>
                            {{ formatNumber(item.tun_pph) }}
                          </td>
                          <td style="border: 1px solid #000">
                            <span :style="printNewLine(item.print_sub_bagian)">
                            </span>
                            {{ formatNumber(item.tun_pph + item.jml_bruto) }}
                          </td>
                          <td style="border: 1px solid #000">
                            <span :style="printNewLine(item.print_sub_bagian)">
                            </span>
                            {{ formatNumber(item.pot_kesehatan) }}
                          </td>
                          <td style="border: 1px solid #000">
                            <span :style="printNewLine(item.print_sub_bagian)">
                            </span>
                            {{ formatNumber(item.pot_bpjs_tk_tiga_program) }}
                          </td>
                          <td style="border: 1px solid #000">
                            <span :style="printNewLine(item.print_sub_bagian)">
                            </span>
                            {{ formatNumber(item.pot_bpjs_tk_empat_program) }}
                          </td>
                          <td style="border: 1px solid #000">
                            <span :style="printNewLine(item.print_sub_bagian)">
                            </span>
                            {{ formatNumber(item.pot_pensiun) }}
                          </td>
                          <td style="border: 1px solid #000">
                            <span :style="printNewLine(item.ifg_mandiri)">
                            </span>
                            {{ formatNumber(item.ifg_mandiri) }}
                          </td>

                          <td style="border: 1px solid #000">
                            <span :style="printNewLine(item.print_sub_bagian)">
                            </span>
                            {{ formatNumber(item.pot_pph) }}
                          </td>
                          <td style="border: 1px solid #000">
                            <span :style="printNewLine(item.print_sub_bagian)">
                            </span>
                            {{ formatNumber(item.total_diterima) }}
                          </td>
                          <td
                            style="border: 1px solid #000"
                            class="bottom-text"
                          >
                            <span :style="printNewLine(item.print_sub_bagian)">
                            </span>
                            {{ index + 1 }}
                          </td>
                          <td class="bottom-text">
                            <span :style="printNewLine(item.print_sub_bagian)">
                            </span
                            >...............
                          </td>
                        </tr>
                      </tbody>

                      <tr
                        class="top-text table-row-vfor"
                        v-if="gajis.totalGajis"
                      >
                        <td style="border: 1px solid #000"></td>
                        <td style="border: 1px solid #000; font-weight: bold">
                          JUMLAH
                        </td>
                        <td style="border: 1px solid #000"></td>
                        <td style="border: 1px solid #000"></td>

                        <td style="border: 1px solid #000; font-weight: bold">
                          {{
                            getSums(
                              [
                                {
                                  indexs: ["riwayat_pekerjaan", "cabang_id"],
                                  val: cabang.id,
                                },
                                {
                                  indexs: ["riwayat_pekerjaan", "bagian_id"],
                                  val: bagian.id,
                                },
                              ],
                              "gajis",
                              "gaji_pokok",
                            )
                          }}
                        </td>

                        <td style="border: 1px solid #000; font-weight: bold">
                          {{
                            getSums(
                              [
                                {
                                  indexs: ["riwayat_pekerjaan", "cabang_id"],
                                  val: cabang.id,
                                },
                                {
                                  indexs: ["riwayat_pekerjaan", "bagian_id"],
                                  val: bagian.id,
                                },
                              ],
                              "gajis",
                              "tun_perusahaan",
                            )
                          }}
                        </td>

                        <td style="border: 1px solid #000; font-weight: bold">
                          {{
                            getSums(
                              [
                                {
                                  indexs: ["riwayat_pekerjaan", "cabang_id"],
                                  val: cabang.id,
                                },
                                {
                                  indexs: ["riwayat_pekerjaan", "bagian_id"],
                                  val: bagian.id,
                                },
                              ],
                              "gajis",
                              "tun_jabatan",
                            )
                          }}
                        </td>

                        <td style="border: 1px solid #000; font-weight: bold">
                          {{
                            getSums(
                              [
                                {
                                  indexs: ["riwayat_pekerjaan", "cabang_id"],
                                  val: cabang.id,
                                },
                                {
                                  indexs: ["riwayat_pekerjaan", "bagian_id"],
                                  val: bagian.id,
                                },
                              ],
                              "gajis",
                              "tun_kemahalan",
                            )
                          }}
                        </td>

                        <td style="border: 1px solid #000; font-weight: bold">
                          {{
                            getSums(
                              [
                                {
                                  indexs: ["riwayat_pekerjaan", "cabang_id"],
                                  val: cabang.id,
                                },
                                {
                                  indexs: ["riwayat_pekerjaan", "bagian_id"],
                                  val: bagian.id,
                                },
                              ],
                              "gajis",
                              "tun_air",
                            )
                          }}
                        </td>

                        <td style="border: 1px solid #000; font-weight: bold">
                          {{
                            getSums(
                              [
                                {
                                  indexs: ["riwayat_pekerjaan", "cabang_id"],
                                  val: cabang.id,
                                },
                                {
                                  indexs: ["riwayat_pekerjaan", "bagian_id"],
                                  val: bagian.id,
                                },
                              ],
                              "gajis",
                              "tun_transport",
                            )
                          }}
                        </td>

                        <td style="border: 1px solid #000; font-weight: bold">
                          {{
                            getSums(
                              [
                                {
                                  indexs: ["riwayat_pekerjaan", "cabang_id"],
                                  val: cabang.id,
                                },
                                {
                                  indexs: ["riwayat_pekerjaan", "bagian_id"],
                                  val: bagian.id,
                                },
                              ],
                              "gajis",
                              "tun_pangan",
                            )
                          }}
                        </td>

                        <td style="border: 1px solid #000; font-weight: bold">
                          {{
                            getSums(
                              [
                                {
                                  indexs: ["riwayat_pekerjaan", "cabang_id"],
                                  val: cabang.id,
                                },
                                {
                                  indexs: ["riwayat_pekerjaan", "bagian_id"],
                                  val: bagian.id,
                                },
                              ],
                              "gajis",
                              "tun_kesehatan",
                            )
                          }}
                        </td>
                        <td style="border: 1px solid #000; font-weight: bold">
                          {{
                            getSums(
                              [
                                {
                                  indexs: ["riwayat_pekerjaan", "cabang_id"],
                                  val: cabang.id,
                                },
                                {
                                  indexs: ["riwayat_pekerjaan", "bagian_id"],
                                  val: bagian.id,
                                },
                              ],
                              "gajis",
                              "premi_jkk",
                            )
                          }}
                        </td>
                        <td style="border: 1px solid #000; font-weight: bold">
                          {{
                            getSums(
                              [
                                {
                                  indexs: ["riwayat_pekerjaan", "cabang_id"],
                                  val: cabang.id,
                                },
                                {
                                  indexs: ["riwayat_pekerjaan", "bagian_id"],
                                  val: bagian.id,
                                },
                              ],
                              "gajis",
                              "premi_jkm",
                            )
                          }}
                        </td>

                        <td style="border: 1px solid #000; font-weight: bold">
                          {{
                            getSums(
                              [
                                {
                                  indexs: ["riwayat_pekerjaan", "cabang_id"],
                                  val: cabang.id,
                                },
                                {
                                  indexs: ["riwayat_pekerjaan", "bagian_id"],
                                  val: bagian.id,
                                },
                              ],
                              "gajis",
                              "jml_tdk_hadir",
                            )
                          }}
                        </td>

                        <td style="border: 1px solid #000; font-weight: bold">
                          {{
                            getSums(
                              [
                                {
                                  indexs: ["riwayat_pekerjaan", "cabang_id"],
                                  val: cabang.id,
                                },
                                {
                                  indexs: ["riwayat_pekerjaan", "bagian_id"],
                                  val: bagian.id,
                                },
                              ],
                              "gajis",
                              "pot_5_persen",
                            )
                          }}
                        </td>

                        <td style="border: 1px solid #000; font-weight: bold">
                          {{
                            getSums(
                              [
                                {
                                  indexs: ["riwayat_pekerjaan", "cabang_id"],
                                  val: cabang.id,
                                },
                                {
                                  indexs: ["riwayat_pekerjaan", "bagian_id"],
                                  val: bagian.id,
                                },
                              ],
                              "gajis",
                              "jml_bruto",
                            )
                          }}
                        </td>

                        <td style="border: 1px solid #000; font-weight: bold">
                          {{
                            getSums(
                              [
                                {
                                  indexs: ["riwayat_pekerjaan", "cabang_id"],
                                  val: cabang.id,
                                },
                                {
                                  indexs: ["riwayat_pekerjaan", "bagian_id"],
                                  val: bagian.id,
                                },
                              ],
                              "gajis",
                              "tun_pph",
                            )
                          }}
                        </td>
                        <td style="border: 1px solid #000; font-weight: bold">
                          {{
                            getSumsColJml(
                              [
                                {
                                  indexs: ["riwayat_pekerjaan", "cabang_id"],
                                  val: cabang.id,
                                },
                                {
                                  indexs: ["riwayat_pekerjaan", "bagian_id"],
                                  val: bagian.id,
                                },
                              ],
                              "gajis",
                            )
                          }}
                        </td>
                        <td style="border: 1px solid #000; font-weight: bold">
                          {{
                            getSums(
                              [
                                {
                                  indexs: ["riwayat_pekerjaan", "cabang_id"],
                                  val: cabang.id,
                                },
                                {
                                  indexs: ["riwayat_pekerjaan", "bagian_id"],
                                  val: bagian.id,
                                },
                              ],
                              "gajis",
                              "pot_kesehatan",
                            )
                          }}
                        </td>
                        <td style="border: 1px solid #000; font-weight: bold">
                          {{
                            getSums(
                              [
                                {
                                  indexs: ["riwayat_pekerjaan", "cabang_id"],
                                  val: cabang.id,
                                },
                                {
                                  indexs: ["riwayat_pekerjaan", "bagian_id"],
                                  val: bagian.id,
                                },
                              ],
                              "gajis",
                              "pot_bpjs_tk_tiga_program",
                            )
                          }}
                        </td>
                        <td style="border: 1px solid #000; font-weight: bold">
                          {{
                            getSums(
                              [
                                {
                                  indexs: ["riwayat_pekerjaan", "cabang_id"],
                                  val: cabang.id,
                                },
                                {
                                  indexs: ["riwayat_pekerjaan", "bagian_id"],
                                  val: bagian.id,
                                },
                              ],
                              "gajis",
                              "pot_bpjs_tk_empat_program",
                            )
                          }}
                        </td>
                        <td style="border: 1px solid #000; font-weight: bold">
                          {{
                            getSums(
                              [
                                {
                                  indexs: ["riwayat_pekerjaan", "cabang_id"],
                                  val: cabang.id,
                                },
                                {
                                  indexs: ["riwayat_pekerjaan", "bagian_id"],
                                  val: bagian.id,
                                },
                              ],
                              "gajis",
                              "pot_pensiun",
                            )
                          }}
                        </td>
                        <td style="border: 1px solid #000; font-weight: bold">
                          {{
                            getSums(
                              [
                                {
                                  indexs: ["riwayat_pekerjaan", "cabang_id"],
                                  val: cabang.id,
                                },
                                {
                                  indexs: ["riwayat_pekerjaan", "bagian_id"],
                                  val: bagian.id,
                                },
                              ],
                              "gajis",
                              "ifg_mandiri",
                            )
                          }}
                        </td>

                        <td style="border: 1px solid #000; font-weight: bold">
                          {{
                            getSums(
                              [
                                {
                                  indexs: ["riwayat_pekerjaan", "cabang_id"],
                                  val: cabang.id,
                                },
                                {
                                  indexs: ["riwayat_pekerjaan", "bagian_id"],
                                  val: bagian.id,
                                },
                              ],
                              "gajis",
                              "pot_pph",
                            )
                          }}
                        </td>
                        <td style="border: 1px solid #000; font-weight: bold">
                          {{
                            getSums(
                              [
                                {
                                  indexs: ["riwayat_pekerjaan", "cabang_id"],
                                  val: cabang.id,
                                },
                                {
                                  indexs: ["riwayat_pekerjaan", "bagian_id"],
                                  val: bagian.id,
                                },
                              ],
                              "gajis",
                              "total_diterima",
                            )
                          }}
                        </td>
                        <td
                          style="border: 1px solid #000"
                          class="bottom-text"
                        ></td>
                        <td class="bottom-text"></td>
                      </tr>
                      <!-- <tr></tr> -->
                    </table>
                    <div class="row arial12" v-if="gajis">
                      <div class="col-12">
                        <p>
                          Terbilang : -----
                          {{
                            formatNumberTerbilang(
                              getSumsColJml(
                                [
                                  {
                                    indexs: ["riwayat_pekerjaan", "cabang_id"],
                                    val: cabang.id,
                                  },
                                  {
                                    indexs: ["riwayat_pekerjaan", "bagian_id"],
                                    val: bagian.id,
                                  },
                                ],
                                "gajis",
                              ),
                            )
                          }}
                          Rupiah -----
                        </p>
                      </div>
                      <div class="row" style="text-align: center">
                        <div class="col-4">
                          Perumda Air Minum <br />
                          Tirta Hita Buleleng <br />
                          Mengetahui: <br />
                          <br />

                          <div
                            style="
                              text-decoration: underline;
                              padding-top: 35px;
                            "
                            v-if="pejabat.dirum"
                          >
                            {{ pejabat.dirum.nama }}
                          </div>

                          Direktur Umum
                        </div>
                        <div class="col-4">
                          <br />
                          <br />

                          Diperiksa:<br />
                          <br />

                          <!-- <div
                            style="
                              text-decoration: underline;
                              padding-top: 35px;
                            "
                            v-if="pejabatMengetahui"
                          >
                            {{ pejabatMengetahui.nama }}
                          </div>
                          Kepala Bagian Umum -->
                          <div
                            style="
                              text-decoration: underline;
                              padding-top: 35px;
                            "
                            v-if="pejabat.pejabatMengetahui"
                          >
                            {{ pejabat.pejabatMengetahui.nama }}
                          </div>
                          <div v-if="pejabat.pejabatMengetahui">
                            {{ pejabat.pejabatMengetahui.jabatan }}
                          </div>
                        </div>
                        <div class="col-4">
                          <br />

                          Singaraja,
                          {{ this.pejabatMembuatTgl }}
                          <br />

                          Dibuat Oleh:<br />
                          <br />

                          <div
                            style="
                              text-decoration: underline;
                              padding-top: 35px;
                            "
                            v-if="pejabat.pejabatMembuat"
                          >
                            {{ pejabat.pejabatMembuat.nama }}
                          </div>
                          <div v-if="pejabat.pejabatMembuat">
                            {{ pejabat.pejabatMembuat.jabatan }}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- /col-12  -->
          </div>
        </div>
        <!-- /bagians-->

        <div v-for="bidang in bidangs" :key="bidang.id">
          <div class="row add-page-break-after">
            <div class="col-12">
              <div class="p-3 mb-3">
                <div class="row">
                  <div class="col-12">
                    <h5
                      style="
                        font-weight: bold;
                        font-family: Arial, sans-serif;
                        font-size: 12px;
                      "
                    >
                      PERUSAHAAN UMUM DAERAH AIR MINUM
                    </h5>
                    <h5
                      style="
                        font-weight: bold;
                        font-family: Arial, sans-serif;
                        font-size: 12px;
                      "
                    >
                      TIRTA HITA BULELENG
                    </h5>
                    <h4 class="header-title">
                      <strong
                        >DAFTAR PEMBAYARAN GAJI BIDANG
                        {{ toUpper(bidang.nama) }}
                      </strong>
                    </h4>
                    <h5 class="header-periode" style="padding-bottom: 20px">
                      <strong
                        >UNTUK BULAN: {{ printBulanNama() }}
                        {{ printTahun() }}</strong
                      >
                    </h5>

                    <table class="table" v-if="gajis">
                      <thead>
                        <tr class="center-top-text">
                          <th rowspan="3">NO</th>
                          <th rowspan="3" style="min-width: 120px">
                            NAMA<br />
                            <br />NIP/NIK<br />JABATAN
                          </th>
                          <th rowspan="3" colspan="2" style="width: 3%">
                            GOL.
                          </th>
                          <th rowspan="2">GAJI<br />POKOK</th>
                          <th colspan="9" rowspan="1">TUNJANGAN</th>
                          <th colspan="2" rowspan="1">POT. KETIDAKHADIRAN</th>
                          <th rowspan="2">
                            JUMLAH<br />
                            BRUTO
                          </th>
                          <th rowspan="2">TUNJANGAN<br />PPH</th>
                          <th rowspan="2">JUMLAH<br />(15+16)</th>
                          <th rowspan="1" colspan="6">POTONGAN</th>
                          <th rowspan="2">JUMLAH<br />DITERIMA</th>
                          <th
                            rowspan="3"
                            style="width: 2%"
                            class="no-right-border"
                          >
                            &nbsp;
                          </th>
                          <th rowspan="3">TANDA TANGAN</th>
                        </tr>

                        <tr class="center-top-text">
                          <th style="width: 5%">
                            PERUSAHAAN
                            <div class="small-text">(5)x 25%</div>
                          </th>
                          <th>JABATAN</th>
                          <th>
                            KEMAHALAN
                            <div class="small-text">(5)x 5%</div>
                          </th>
                          <th>AIR</th>
                          <th>TRANSPORT</th>
                          <th>PANGAN</th>
                          <th>KESEHATAN</th>
                          <th>PREMI JKK</th>
                          <th>PREMI JKM</th>
                          <th>HARI</th>
                          <th>
                            JUMLAH
                            <div class="small-text">13X5%(6+10)</div>
                          </th>
                          <th>KESEHATAN</th>
                          <th>
                            BPJS TK<br />3 PROGRAM
                            <div class="small-text">(15)X2%</div>
                          </th>
                          <th>
                            BPJS TK<br />4 PROGRAM
                            <div class="small-text">(15)X3%</div>
                          </th>
                          <th>PENSIUN<br />IFG LIFE</th>
                          <th>IFG<br />MANDIRI</th>
                          <th>PPH<br />PASAL 21</th>
                        </tr>

                        <tr class="center-top-text">
                          <th style="border: none">(Rp.)</th>
                          <th>(Rp.)</th>
                          <th>(Rp.)</th>
                          <th>(Rp.)</th>
                          <th>(Rp.)</th>
                          <th>(Rp.)</th>
                          <th>(Rp.)</th>
                          <th>(Rp.)</th>
                          <th>(Rp.)</th>

                          <th>(Rp.)</th>
                          <th></th>
                          <th>(Rp.)</th>
                          <th>(Rp.)</th>
                          <th>(Rp.)</th>
                          <th>(Rp.)</th>
                          <th>(Rp.)</th>
                          <th>(Rp.)</th>
                          <th>(Rp.)</th>
                          <th>(Rp.)</th>
                          <th>(Rp.)</th>
                          <th>(Rp.)</th>
                          <th>(Rp.)</th>
                        </tr>
                        <tr class="center-top-text">
                          <th>1</th>
                          <th>2</th>
                          <th>3</th>
                          <th>4</th>
                          <th>5</th>
                          <th>6</th>
                          <th>7</th>
                          <th>8</th>
                          <th>9</th>
                          <th>10</th>
                          <th>11</th>
                          <th>12</th>
                          <th>13</th>
                          <th>14</th>
                          <th>15</th>
                          <th>16</th>
                          <th>17</th>
                          <th>18</th>
                          <th>19</th>
                          <th>20</th>
                          <th>21</th>
                          <th>22</th>
                          <th>23</th>
                          <th>24</th>
                          <th>25</th>
                          <th>26</th>
                          <th></th>
                          <th>27</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr
                          v-for="(item, index) in filterGajisByConditions(
                            [
                              {
                                indexs: ['riwayat_pekerjaan', 'cabang_id'],
                                val: cabang.id,
                              },
                              {
                                indexs: ['riwayat_pekerjaan', 'bidang_id'],
                                val: bidang.id,
                              },
                            ],
                            'sub_bidang_id',
                            'gajis',
                          )"
                          :key="item.id"
                          :class="getPageBreakStyle(index)"
                        >
                          <td style="border: 1px solid #000">
                            <span
                              :style="printNewLine(item.print_sub_bagian)"
                              v-if="subBidangs"
                            >
                            </span>
                            {{ index + 1 }}
                          </td>
                          <td style="border: 1px solid #000">
                            <div :style="boldStyle">
                              <!-- v-if="shouldRenderSubBagian" -->
                              {{
                                printSubBagian(
                                  item.print_sub_bagian,
                                  item.riwayat_pekerjaan,
                                )
                              }}
                            </div>
                            {{ item.pegawai.nama }}
                            <br />NIK.
                            {{ item.pegawai.nik }}
                          </td>
                          <td style="border: 1px solid #000">
                            <span :style="printNewLine(item.print_sub_bagian)">
                            </span>
                            {{ item.golongan.nama }}
                          </td>

                          <td style="border: 1px solid #000">
                            <span :style="printNewLine(item.print_sub_bagian)">
                            </span>
                            <!-- {{ item.pegawai.status_ptkp }} -->
                            {{ item.pph ? item.pph.ptkp : "" }}
                          </td>

                          <td style="border: 1px solid #000">
                            <span :style="printNewLine(item.print_sub_bagian)">
                            </span>
                            {{ formatNumber(item.gaji_pokok) }}
                          </td>

                          <td style="border: 1px solid #000">
                            <span :style="printNewLine(item.print_sub_bagian)">
                            </span>
                            {{ formatNumber(item.tun_perusahaan) }}
                          </td>

                          <td style="border: 1px solid #000">
                            <span :style="printNewLine(item.print_sub_bagian)">
                            </span>
                            {{ formatNumber(item.tun_jabatan) }}
                          </td>

                          <td style="border: 1px solid #000">
                            <span :style="printNewLine(item.print_sub_bagian)">
                            </span>
                            {{ formatNumber(item.tun_kemahalan) }}
                          </td>

                          <td style="border: 1px solid #000">
                            <span :style="printNewLine(item.print_sub_bagian)">
                            </span>
                            {{ formatNumber(item.tun_air) }}
                          </td>

                          <td style="border: 1px solid #000">
                            <span :style="printNewLine(item.print_sub_bagian)">
                            </span>
                            {{ formatNumber(item.tun_transport) }}
                          </td>

                          <td style="border: 1px solid #000">
                            <span :style="printNewLine(item.print_sub_bagian)">
                            </span>
                            {{ formatNumber(item.tun_pangan) }}
                          </td>

                          <td style="border: 1px solid #000">
                            <span :style="printNewLine(item.print_sub_bagian)">
                            </span>
                            {{ formatNumber(item.tun_kesehatan) }}
                          </td>
                          <td style="border: 1px solid #000">
                            <span :style="printNewLine(item.print_sub_bagian)">
                            </span>
                            {{ formatNumber(item.premi_jkk) }}
                          </td>
                          <td style="border: 1px solid #000">
                            <span :style="printNewLine(item.print_sub_bagian)">
                            </span>
                            {{ formatNumber(item.premi_jkm) }}
                          </td>

                          <td style="border: 1px solid #000">
                            <span :style="printNewLine(item.print_sub_bagian)">
                            </span>
                            {{ formatNumber(item.jml_tdk_hadir) }}
                          </td>

                          <td style="border: 1px solid #000">
                            <span :style="printNewLine(item.print_sub_bagian)">
                            </span>
                            {{ formatNumber(item.pot_5_persen) }}
                          </td>

                          <td style="border: 1px solid #000">
                            <span :style="printNewLine(item.print_sub_bagian)">
                            </span>
                            {{ formatNumber(item.jml_bruto) }}
                          </td>

                          <td style="border: 1px solid #000">
                            <span :style="printNewLine(item.print_sub_bagian)">
                            </span>
                            {{ formatNumber(item.tun_pph) }}
                          </td>
                          <td style="border: 1px solid #000">
                            <span :style="printNewLine(item.print_sub_bagian)">
                            </span>
                            {{ formatNumber(item.tun_pph + item.jml_bruto) }}
                          </td>
                          <td style="border: 1px solid #000">
                            <span :style="printNewLine(item.print_sub_bagian)">
                            </span>
                            {{ formatNumber(item.pot_kesehatan) }}
                          </td>
                          <td style="border: 1px solid #000">
                            <span :style="printNewLine(item.print_sub_bagian)">
                            </span>
                            {{ formatNumber(item.pot_bpjs_tk_tiga_program) }}
                          </td>
                          <td style="border: 1px solid #000">
                            <span :style="printNewLine(item.print_sub_bagian)">
                            </span>
                            {{ formatNumber(item.pot_bpjs_tk_empat_program) }}
                          </td>
                          <td style="border: 1px solid #000">
                            <span :style="printNewLine(item.print_sub_bagian)">
                            </span>
                            {{ formatNumber(item.pot_pensiun) }}
                          </td>
                          <td style="border: 1px solid #000">
                            <span :style="printNewLine(item.print_sub_bagian)">
                            </span>
                            {{ formatNumber(item.ifg_mandiri) }}
                          </td>

                          <td style="border: 1px solid #000">
                            <span :style="printNewLine(item.print_sub_bagian)">
                            </span>
                            {{ formatNumber(item.pot_pph) }}
                          </td>
                          <td style="border: 1px solid #000">
                            <span :style="printNewLine(item.print_sub_bagian)">
                            </span>
                            {{ formatNumber(item.total_diterima) }}
                          </td>
                          <td
                            style="border: 1px solid #000"
                            class="bottom-text"
                          >
                            <span :style="printNewLine(item.print_sub_bagian)">
                            </span>
                            {{ index + 1 }}
                          </td>
                          <td class="bottom-text">
                            <span :style="printNewLine(item.print_sub_bagian)">
                            </span
                            >...............
                          </td>
                        </tr>
                      </tbody>

                      <tr
                        class="top-text table-row-vfor"
                        v-if="gajis.totalGajis"
                      >
                        <td
                          style="border: 1px solid #000; font-weight: bold"
                        ></td>
                        <td style="border: 1px solid #000; font-weight: bold">
                          JUMLAH
                        </td>
                        <td
                          style="border: 1px solid #000; font-weight: bold"
                        ></td>
                        <td
                          style="border: 1px solid #000; font-weight: bold"
                        ></td>

                        <td style="border: 1px solid #000; font-weight: bold">
                          {{
                            getSums(
                              [
                                {
                                  indexs: ["riwayat_pekerjaan", "cabang_id"],
                                  val: cabang.id,
                                },
                                {
                                  indexs: ["riwayat_pekerjaan", "bidang_id"],
                                  val: bidang.id,
                                },
                              ],
                              "gajis",
                              "gaji_pokok",
                            )
                          }}
                        </td>

                        <td style="border: 1px solid #000; font-weight: bold">
                          {{
                            getSums(
                              [
                                {
                                  indexs: ["riwayat_pekerjaan", "cabang_id"],
                                  val: cabang.id,
                                },
                                {
                                  indexs: ["riwayat_pekerjaan", "bidang_id"],
                                  val: bidang.id,
                                },
                              ],
                              "gajis",
                              "tun_perusahaan",
                            )
                          }}
                        </td>

                        <td style="border: 1px solid #000; font-weight: bold">
                          {{
                            getSums(
                              [
                                {
                                  indexs: ["riwayat_pekerjaan", "cabang_id"],
                                  val: cabang.id,
                                },
                                {
                                  indexs: ["riwayat_pekerjaan", "bidang_id"],
                                  val: bidang.id,
                                },
                              ],
                              "gajis",
                              "tun_jabatan",
                            )
                          }}
                        </td>

                        <td style="border: 1px solid #000; font-weight: bold">
                          {{
                            getSums(
                              [
                                {
                                  indexs: ["riwayat_pekerjaan", "cabang_id"],
                                  val: cabang.id,
                                },
                                {
                                  indexs: ["riwayat_pekerjaan", "bidang_id"],
                                  val: bidang.id,
                                },
                              ],
                              "gajis",
                              "tun_kemahalan",
                            )
                          }}
                        </td>

                        <td style="border: 1px solid #000; font-weight: bold">
                          {{
                            getSums(
                              [
                                {
                                  indexs: ["riwayat_pekerjaan", "cabang_id"],
                                  val: cabang.id,
                                },
                                {
                                  indexs: ["riwayat_pekerjaan", "bidang_id"],
                                  val: bidang.id,
                                },
                              ],
                              "gajis",
                              "tun_air",
                            )
                          }}
                        </td>

                        <td style="border: 1px solid #000; font-weight: bold">
                          {{
                            getSums(
                              [
                                {
                                  indexs: ["riwayat_pekerjaan", "cabang_id"],
                                  val: cabang.id,
                                },
                                {
                                  indexs: ["riwayat_pekerjaan", "bidang_id"],
                                  val: bidang.id,
                                },
                              ],
                              "gajis",
                              "tun_transport",
                            )
                          }}
                        </td>

                        <td style="border: 1px solid #000; font-weight: bold">
                          {{
                            getSums(
                              [
                                {
                                  indexs: ["riwayat_pekerjaan", "cabang_id"],
                                  val: cabang.id,
                                },
                                {
                                  indexs: ["riwayat_pekerjaan", "bidang_id"],
                                  val: bidang.id,
                                },
                              ],
                              "gajis",
                              "tun_pangan",
                            )
                          }}
                        </td>

                        <td style="border: 1px solid #000; font-weight: bold">
                          {{
                            getSums(
                              [
                                {
                                  indexs: ["riwayat_pekerjaan", "cabang_id"],
                                  val: cabang.id,
                                },
                                {
                                  indexs: ["riwayat_pekerjaan", "bidang_id"],
                                  val: bidang.id,
                                },
                              ],
                              "gajis",
                              "tun_kesehatan",
                            )
                          }}
                        </td>
                        <td style="border: 1px solid #000; font-weight: bold">
                          {{
                            getSums(
                              [
                                {
                                  indexs: ["riwayat_pekerjaan", "cabang_id"],
                                  val: cabang.id,
                                },
                                {
                                  indexs: ["riwayat_pekerjaan", "bidang_id"],
                                  val: bidang.id,
                                },
                              ],
                              "gajis",
                              "premi_jkk",
                            )
                          }}
                        </td>
                        <td style="border: 1px solid #000; font-weight: bold">
                          {{
                            getSums(
                              [
                                {
                                  indexs: ["riwayat_pekerjaan", "cabang_id"],
                                  val: cabang.id,
                                },
                                {
                                  indexs: ["riwayat_pekerjaan", "bidang_id"],
                                  val: bidang.id,
                                },
                              ],
                              "gajis",
                              "premi_jkm",
                            )
                          }}
                        </td>

                        <td style="border: 1px solid #000; font-weight: bold">
                          {{
                            getSums(
                              [
                                {
                                  indexs: ["riwayat_pekerjaan", "cabang_id"],
                                  val: cabang.id,
                                },
                                {
                                  indexs: ["riwayat_pekerjaan", "bidang_id"],
                                  val: bidang.id,
                                },
                              ],
                              "gajis",
                              "jml_tdk_hadir",
                            )
                          }}
                        </td>

                        <td style="border: 1px solid #000; font-weight: bold">
                          {{
                            getSums(
                              [
                                {
                                  indexs: ["riwayat_pekerjaan", "cabang_id"],
                                  val: cabang.id,
                                },
                                {
                                  indexs: ["riwayat_pekerjaan", "bidang_id"],
                                  val: bidang.id,
                                },
                              ],
                              "gajis",
                              "pot_5_persen",
                            )
                          }}
                        </td>

                        <td style="border: 1px solid #000; font-weight: bold">
                          {{
                            getSums(
                              [
                                {
                                  indexs: ["riwayat_pekerjaan", "cabang_id"],
                                  val: cabang.id,
                                },
                                {
                                  indexs: ["riwayat_pekerjaan", "bidang_id"],
                                  val: bidang.id,
                                },
                              ],
                              "gajis",
                              "jml_bruto",
                            )
                          }}
                        </td>

                        <td style="border: 1px solid #000; font-weight: bold">
                          {{
                            getSums(
                              [
                                {
                                  indexs: ["riwayat_pekerjaan", "cabang_id"],
                                  val: cabang.id,
                                },
                                {
                                  indexs: ["riwayat_pekerjaan", "bidang_id"],
                                  val: bidang.id,
                                },
                              ],
                              "gajis",
                              "tun_pph",
                            )
                          }}
                        </td>
                        <td style="border: 1px solid #000; font-weight: bold">
                          {{
                            getSumsColJml(
                              [
                                {
                                  indexs: ["riwayat_pekerjaan", "cabang_id"],
                                  val: cabang.id,
                                },
                                {
                                  indexs: ["riwayat_pekerjaan", "bidang_id"],
                                  val: bidang.id,
                                },
                              ],
                              "gajis",
                            )
                          }}
                        </td>
                        <td style="border: 1px solid #000; font-weight: bold">
                          {{
                            getSums(
                              [
                                {
                                  indexs: ["riwayat_pekerjaan", "cabang_id"],
                                  val: cabang.id,
                                },
                                {
                                  indexs: ["riwayat_pekerjaan", "bidang_id"],
                                  val: bidang.id,
                                },
                              ],
                              "gajis",
                              "pot_kesehatan",
                            )
                          }}
                        </td>
                        <td style="border: 1px solid #000; font-weight: bold">
                          {{
                            getSums(
                              [
                                {
                                  indexs: ["riwayat_pekerjaan", "cabang_id"],
                                  val: cabang.id,
                                },
                                {
                                  indexs: ["riwayat_pekerjaan", "bidang_id"],
                                  val: bidang.id,
                                },
                              ],
                              "gajis",
                              "pot_bpjs_tk_tiga_program",
                            )
                          }}
                        </td>
                        <td style="border: 1px solid #000; font-weight: bold">
                          {{
                            getSums(
                              [
                                {
                                  indexs: ["riwayat_pekerjaan", "cabang_id"],
                                  val: cabang.id,
                                },
                                {
                                  indexs: ["riwayat_pekerjaan", "bidang_id"],
                                  val: bidang.id,
                                },
                              ],
                              "gajis",
                              "pot_bpjs_tk_empat_program",
                            )
                          }}
                        </td>
                        <td style="border: 1px solid #000; font-weight: bold">
                          {{
                            getSums(
                              [
                                {
                                  indexs: ["riwayat_pekerjaan", "cabang_id"],
                                  val: cabang.id,
                                },
                                {
                                  indexs: ["riwayat_pekerjaan", "bidang_id"],
                                  val: bidang.id,
                                },
                              ],
                              "gajis",
                              "pot_pensiun",
                            )
                          }}
                        </td>
                        <td style="border: 1px solid #000; font-weight: bold">
                          {{
                            getSums(
                              [
                                {
                                  indexs: ["riwayat_pekerjaan", "cabang_id"],
                                  val: cabang.id,
                                },
                                {
                                  indexs: ["riwayat_pekerjaan", "bidang_id"],
                                  val: bidang.id,
                                },
                              ],
                              "gajis",
                              "ifg_mandiri",
                            )
                          }}
                        </td>
                        <td style="border: 1px solid #000; font-weight: bold">
                          {{
                            getSums(
                              [
                                {
                                  indexs: ["riwayat_pekerjaan", "cabang_id"],
                                  val: cabang.id,
                                },
                                {
                                  indexs: ["riwayat_pekerjaan", "bidang_id"],
                                  val: bidang.id,
                                },
                              ],
                              "gajis",
                              "pot_pph",
                            )
                          }}
                        </td>
                        <td style="border: 1px solid #000; font-weight: bold">
                          {{
                            getSums(
                              [
                                {
                                  indexs: ["riwayat_pekerjaan", "cabang_id"],
                                  val: cabang.id,
                                },
                                {
                                  indexs: ["riwayat_pekerjaan", "bidang_id"],
                                  val: bidang.id,
                                },
                              ],
                              "gajis",
                              "total_diterima",
                            )
                          }}
                        </td>
                        <td
                          style="border: 1px solid #000; font-weight: bold"
                          class="bottom-text"
                        ></td>
                        <td class="bottom-text"></td>
                      </tr>
                      <!-- <tr></tr> -->
                    </table>
                    <div class="row arial12" v-if="gajis">
                      <div class="col-12">
                        <p>
                          Terbilang : -----
                          {{
                            formatNumberTerbilang(
                              getSumsColJml(
                                [
                                  {
                                    indexs: ["riwayat_pekerjaan", "cabang_id"],
                                    val: cabang.id,
                                  },
                                  {
                                    indexs: ["riwayat_pekerjaan", "bidang_id"],
                                    val: bidang.id,
                                  },
                                ],
                                "gajis",
                              ),
                            )
                          }}
                          Rupiah -----
                        </p>
                      </div>
                      <div class="row" style="text-align: center">
                        <div class="col-4">
                          Perumda Air Minum <br />
                          Tirta Hita Buleleng <br />
                          Mengetahui: <br />
                          <br />

                          <div
                            style="
                              text-decoration: underline;
                              padding-top: 35px;
                            "
                            v-if="pejabat.dirum"
                          >
                            {{ pejabat.dirum.nama }}
                          </div>

                          Direktur Umum
                        </div>
                        <div class="col-4">
                          <br />
                          <br />

                          Diperiksa:<br />
                          <br />

                          <!-- <div
                            style="
                              text-decoration: underline;
                              padding-top: 35px;
                            "
                            v-if="pejabatMengetahui"
                          >
                            {{ pejabatMengetahui.nama }}
                          </div>
                          Kepala Bagian Umum -->
                          <div
                            style="
                              text-decoration: underline;
                              padding-top: 35px;
                            "
                            v-if="pejabat.pejabatMengetahui"
                          >
                            {{ pejabat.pejabatMengetahui.nama }}
                          </div>
                          <div v-if="pejabat.pejabatMengetahui">
                            {{ pejabat.pejabatMengetahui.jabatan }}
                          </div>
                        </div>
                        <div class="col-4">
                          <br />

                          Singaraja,
                          {{ this.pejabatMembuatTgl }}
                          <br />

                          Dibuat Oleh:<br />
                          <br />
                          <div
                            style="
                              text-decoration: underline;
                              padding-top: 35px;
                            "
                            v-if="pejabat.pejabatMembuat"
                          >
                            {{ pejabat.pejabatMembuat.nama }}
                          </div>
                          <div v-if="pejabat.pejabatMembuat">
                            {{ pejabat.pejabatMembuat.jabatan }}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- /col-12  -->
          </div>
        </div>
        <!-- /bidangs-->
      </div>
      <!-- /cabangs end of cabang = 1 -->
      <div v-else>
        <div class="row add-page-break-after">
          <div class="col-12">
            <div class="p-3 mb-3">
              <div class="row">
                <div class="col-12">
                  <h5
                    style="
                      font-weight: bold;
                      font-family: Arial, sans-serif;
                      font-size: 12px;
                    "
                  >
                    PERUSAHAAN UMUM DAERAH AIR MINUM
                  </h5>
                  <h5
                    style="
                      font-weight: bold;
                      font-family: Arial, sans-serif;
                      font-size: 12px;
                    "
                  >
                    TIRTA HITA BULELENG
                  </h5>
                  <h4 class="header-title">
                    <strong
                      >DAFTAR PEMBAYARAN GAJI CABANG
                      {{ toUpper(cabang.nama) }}
                    </strong>
                  </h4>
                  <h5 class="header-periode" style="padding-bottom: 20px">
                    <strong
                      >UNTUK BULAN: {{ printBulanNama() }}
                      {{ printTahun() }}</strong
                    >
                  </h5>

                  <table class="table" v-if="gajis">
                    <thead>
                      <tr class="center-top-text">
                        <th rowspan="3">NO</th>
                        <th rowspan="3" style="min-width: 120px">
                          NAMA<br />
                          <br />NIP/NIK<br />JABATAN
                        </th>
                        <th rowspan="3" colspan="2" style="width: 3%">GOL.</th>
                        <th rowspan="2">GAJI<br />POKOK</th>
                        <th colspan="9" rowspan="1">TUNJANGAN</th>
                        <th colspan="2" rowspan="1">POT. KETIDAKHADIRAN</th>
                        <th rowspan="2">
                          JUMLAH<br />
                          BRUTO
                        </th>
                        <th rowspan="2">TUNJANGAN<br />PPH</th>
                        <th rowspan="2">JUMLAH<br />(15+16)</th>
                        <th rowspan="1" colspan="6">POTONGAN</th>
                        <th rowspan="2">JUMLAH<br />DITERIMA</th>
                        <th
                          rowspan="3"
                          style="width: 2%"
                          class="no-right-border"
                        >
                          &nbsp;
                        </th>
                        <th rowspan="3">TANDA TANGAN</th>
                      </tr>

                      <tr class="center-top-text">
                        <th style="width: 5%">
                          PERUSAHAAN
                          <div class="small-text">(5)x 25%</div>
                        </th>
                        <th>JABATAN</th>
                        <th>
                          KEMAHALAN
                          <div class="small-text">(5)x 5%</div>
                        </th>
                        <th>AIR</th>
                        <th>TRANSPORT</th>
                        <th>PANGAN</th>
                        <th>KESEHATAN</th>
                        <th>PREMI JKK</th>
                        <th>PREMI JKM</th>
                        <th>HARI</th>
                        <th>
                          JUMLAH
                          <div class="small-text">13X5%(6+10)</div>
                        </th>
                        <th>KESEHATAN</th>
                        <th>
                          BPJS TK<br />3 PROGRAM
                          <div class="small-text">(15)X2%</div>
                        </th>
                        <th>
                          BPJS TK<br />4 PROGRAM
                          <div class="small-text">(15)X3%</div>
                        </th>
                        <th>PENSIUN<br />IFG LIFE</th>
                        <th>IFG<br />MANDIRI</th>
                        <th>PPH<br />PASAL 21</th>
                      </tr>

                      <tr class="center-top-text">
                        <th style="border: none">(Rp.)</th>
                        <th>(Rp.)</th>
                        <th>(Rp.)</th>
                        <th>(Rp.)</th>
                        <th>(Rp.)</th>
                        <th>(Rp.)</th>
                        <th>(Rp.)</th>
                        <th>(Rp.)</th>
                        <th>(Rp.)</th>

                        <th>(Rp.)</th>
                        <th></th>
                        <th>(Rp.)</th>
                        <th>(Rp.)</th>
                        <th>(Rp.)</th>
                        <th>(Rp.)</th>
                        <th>(Rp.)</th>
                        <th>(Rp.)</th>
                        <th>(Rp.)</th>
                        <th>(Rp.)</th>
                        <th>(Rp.)</th>
                        <th>(Rp.)</th>
                        <th>(Rp.)</th>
                      </tr>
                      <tr class="center-top-text">
                        <th>1</th>
                        <th>2</th>
                        <th>3</th>
                        <th>4</th>
                        <th>5</th>
                        <th>6</th>
                        <th>7</th>
                        <th>8</th>
                        <th>9</th>
                        <th>10</th>
                        <th>11</th>
                        <th>12</th>
                        <th>13</th>
                        <th>14</th>
                        <th>15</th>
                        <th>16</th>
                        <th>17</th>
                        <th>18</th>
                        <th>19</th>
                        <th>20</th>

                        <th>21</th>
                        <th>22</th>
                        <th>23</th>
                        <th>24</th>
                        <th>25</th>
                        <th>26</th>
                        <th></th>
                        <th>27</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        v-for="(item, index) in filterGajisByConditions(
                          [
                            {
                              indexs: ['riwayat_pekerjaan', 'cabang_id'],
                              val: cabang.id,
                            },
                            {
                              indexs: ['riwayat_pekerjaan', 'unit_id'],
                              val: null,
                            },
                          ],
                          'seksis_order',
                          'gajis',
                        )"
                        :key="item.id"
                        :class="getPageBreakStyle(index)"
                      >
                        <td style="border: 1px solid #000">
                          <span
                            :style="printNewLine(item.print_sub_bagian)"
                            v-if="subBagians"
                          >
                          </span>
                          {{ index + 1 }}
                        </td>
                        <td style="border: 1px solid #000">
                          <div :style="boldStyle">
                            <!-- v-if="shouldRenderSubBagian" -->
                            {{
                              printSubBagian(
                                item.print_sub_bagian,
                                item.riwayat_pekerjaan,
                              )
                            }}
                          </div>
                          {{ item.pegawai.nama }}
                          <br />NIK.
                          {{ item.pegawai.nik }}
                        </td>
                        <td style="border: 1px solid #000">
                          <span :style="printNewLine(item.print_sub_bagian)">
                          </span>
                          {{ item.golongan.nama }}
                        </td>

                        <td style="border: 1px solid #000">
                          <span :style="printNewLine(item.print_sub_bagian)">
                          </span>
                          <!-- {{ item.pegawai.status_ptkp }} -->
                          {{ item.pph ? item.pph.ptkp : "" }}
                        </td>

                        <td style="border: 1px solid #000">
                          <span :style="printNewLine(item.print_sub_bagian)">
                          </span>
                          {{ formatNumber(item.gaji_pokok) }}
                        </td>

                        <td style="border: 1px solid #000">
                          <span :style="printNewLine(item.print_sub_bagian)">
                          </span>
                          {{ formatNumber(item.tun_perusahaan) }}
                        </td>

                        <td style="border: 1px solid #000">
                          <span :style="printNewLine(item.print_sub_bagian)">
                          </span>
                          {{ formatNumber(item.tun_jabatan) }}
                        </td>

                        <td style="border: 1px solid #000">
                          <span :style="printNewLine(item.print_sub_bagian)">
                          </span>
                          {{ formatNumber(item.tun_kemahalan) }}
                        </td>

                        <td style="border: 1px solid #000">
                          <span :style="printNewLine(item.print_sub_bagian)">
                          </span>
                          {{ formatNumber(item.tun_air) }}
                        </td>

                        <td style="border: 1px solid #000">
                          <span :style="printNewLine(item.print_sub_bagian)">
                          </span>
                          {{ formatNumber(item.tun_transport) }}
                        </td>

                        <td style="border: 1px solid #000">
                          <span :style="printNewLine(item.print_sub_bagian)">
                          </span>
                          {{ formatNumber(item.tun_pangan) }}
                        </td>

                        <td style="border: 1px solid #000">
                          <span :style="printNewLine(item.print_sub_bagian)">
                          </span>
                          {{ formatNumber(item.tun_kesehatan) }}
                        </td>
                        <td style="border: 1px solid #000">
                          <span :style="printNewLine(item.print_sub_bagian)">
                          </span>
                          {{ formatNumber(item.premi_jkk) }}
                        </td>
                        <td style="border: 1px solid #000">
                          <span :style="printNewLine(item.print_sub_bagian)">
                          </span>
                          {{ formatNumber(item.premi_jkm) }}
                        </td>

                        <td style="border: 1px solid #000">
                          <span :style="printNewLine(item.print_sub_bagian)">
                          </span>
                          {{ formatNumber(item.jml_tdk_hadir) }}
                        </td>

                        <td style="border: 1px solid #000">
                          <span :style="printNewLine(item.print_sub_bagian)">
                          </span>
                          {{ formatNumber(item.pot_5_persen) }}
                        </td>

                        <td style="border: 1px solid #000">
                          <span :style="printNewLine(item.print_sub_bagian)">
                          </span>
                          {{ formatNumber(item.jml_bruto) }}
                        </td>

                        <td style="border: 1px solid #000">
                          <span :style="printNewLine(item.print_sub_bagian)">
                          </span>
                          {{ formatNumber(item.tun_pph) }}
                        </td>
                        <td style="border: 1px solid #000">
                          <span :style="printNewLine(item.print_sub_bagian)">
                          </span>
                          {{ formatNumber(item.tun_pph + item.jml_bruto) }}
                        </td>
                        <td style="border: 1px solid #000">
                          <span :style="printNewLine(item.print_sub_bagian)">
                          </span>
                          {{ formatNumber(item.pot_kesehatan) }}
                        </td>
                        <td style="border: 1px solid #000">
                          <span :style="printNewLine(item.print_sub_bagian)">
                          </span>
                          {{ formatNumber(item.pot_bpjs_tk_tiga_program) }}
                        </td>
                        <td style="border: 1px solid #000">
                          <span :style="printNewLine(item.print_sub_bagian)">
                          </span>
                          {{ formatNumber(item.pot_bpjs_tk_empat_program) }}
                        </td>
                        <td style="border: 1px solid #000">
                          <span :style="printNewLine(item.print_sub_bagian)">
                          </span>
                          {{ formatNumber(item.pot_pensiun) }}
                        </td>
                        <td style="border: 1px solid #000">
                          <span :style="printNewLine(item.print_sub_bagian)">
                          </span>
                          {{ formatNumber(item.ifg_mandiri) }}
                        </td>

                        <td style="border: 1px solid #000">
                          <span :style="printNewLine(item.print_sub_bagian)">
                          </span>
                          {{ formatNumber(item.pot_pph) }}
                        </td>
                        <td style="border: 1px solid #000">
                          <span :style="printNewLine(item.print_sub_bagian)">
                          </span>
                          {{ formatNumber(item.total_diterima) }}
                        </td>
                        <td style="border: 1px solid #000" class="bottom-text">
                          <span :style="printNewLine(item.print_sub_bagian)">
                          </span>
                          {{ index + 1 }}
                        </td>
                        <td class="bottom-text">
                          <span :style="printNewLine(item.print_sub_bagian)">
                          </span
                          >...............
                        </td>
                      </tr>
                    </tbody>

                    <tr class="top-text table-row-vfor" v-if="gajis.totalGajis">
                      <td style="border: 1px solid #000"></td>
                      <td style="border: 1px solid #000; font-weight: bold">
                        JUMLAH
                      </td>
                      <td style="border: 1px solid #000"></td>
                      <td style="border: 1px solid #000"></td>

                      <td style="border: 1px solid #000; font-weight: bold">
                        {{
                          getSums(
                            [
                              {
                                indexs: ["riwayat_pekerjaan", "cabang_id"],
                                val: cabang.id,
                              },
                              {
                                indexs: ["riwayat_pekerjaan", "unit_id"],
                                val: null,
                              },
                            ],
                            "gajis",
                            "gaji_pokok",
                          )
                        }}
                      </td>

                      <td style="border: 1px solid #000; font-weight: bold">
                        {{
                          getSums(
                            [
                              {
                                indexs: ["riwayat_pekerjaan", "cabang_id"],
                                val: cabang.id,
                              },
                              {
                                indexs: ["riwayat_pekerjaan", "unit_id"],
                                val: null,
                              },
                            ],
                            "gajis",
                            "tun_perusahaan",
                          )
                        }}
                      </td>

                      <td style="border: 1px solid #000; font-weight: bold">
                        {{
                          getSums(
                            [
                              {
                                indexs: ["riwayat_pekerjaan", "cabang_id"],
                                val: cabang.id,
                              },
                              {
                                indexs: ["riwayat_pekerjaan", "unit_id"],
                                val: null,
                              },
                            ],
                            "gajis",
                            "tun_jabatan",
                          )
                        }}
                      </td>

                      <td style="border: 1px solid #000; font-weight: bold">
                        {{
                          getSums(
                            [
                              {
                                indexs: ["riwayat_pekerjaan", "cabang_id"],
                                val: cabang.id,
                              },
                              {
                                indexs: ["riwayat_pekerjaan", "unit_id"],
                                val: null,
                              },
                            ],
                            "gajis",
                            "tun_kemahalan",
                          )
                        }}
                      </td>

                      <td style="border: 1px solid #000; font-weight: bold">
                        {{
                          getSums(
                            [
                              {
                                indexs: ["riwayat_pekerjaan", "cabang_id"],
                                val: cabang.id,
                              },
                              {
                                indexs: ["riwayat_pekerjaan", "unit_id"],
                                val: null,
                              },
                            ],
                            "gajis",
                            "tun_air",
                          )
                        }}
                      </td>

                      <td style="border: 1px solid #000; font-weight: bold">
                        {{
                          getSums(
                            [
                              {
                                indexs: ["riwayat_pekerjaan", "cabang_id"],
                                val: cabang.id,
                              },
                              {
                                indexs: ["riwayat_pekerjaan", "unit_id"],
                                val: null,
                              },
                            ],
                            "gajis",
                            "tun_transport",
                          )
                        }}
                      </td>

                      <td style="border: 1px solid #000; font-weight: bold">
                        {{
                          getSums(
                            [
                              {
                                indexs: ["riwayat_pekerjaan", "cabang_id"],
                                val: cabang.id,
                              },
                              {
                                indexs: ["riwayat_pekerjaan", "unit_id"],
                                val: null,
                              },
                            ],
                            "gajis",
                            "tun_pangan",
                          )
                        }}
                      </td>

                      <td style="border: 1px solid #000; font-weight: bold">
                        {{
                          getSums(
                            [
                              {
                                indexs: ["riwayat_pekerjaan", "cabang_id"],
                                val: cabang.id,
                              },
                              {
                                indexs: ["riwayat_pekerjaan", "unit_id"],
                                val: null,
                              },
                            ],
                            "gajis",
                            "tun_kesehatan",
                          )
                        }}
                      </td>
                      <td style="border: 1px solid #000; font-weight: bold">
                        {{
                          getSums(
                            [
                              {
                                indexs: ["riwayat_pekerjaan", "cabang_id"],
                                val: cabang.id,
                              },
                              {
                                indexs: ["riwayat_pekerjaan", "unit_id"],
                                val: null,
                              },
                            ],
                            "gajis",
                            "premi_jkk",
                          )
                        }}
                      </td>
                      <td style="border: 1px solid #000; font-weight: bold">
                        {{
                          getSums(
                            [
                              {
                                indexs: ["riwayat_pekerjaan", "cabang_id"],
                                val: cabang.id,
                              },
                              {
                                indexs: ["riwayat_pekerjaan", "unit_id"],
                                val: null,
                              },
                            ],
                            "gajis",
                            "premi_jkm",
                          )
                        }}
                      </td>

                      <td style="border: 1px solid #000; font-weight: bold">
                        {{
                          getSums(
                            [
                              {
                                indexs: ["riwayat_pekerjaan", "cabang_id"],
                                val: cabang.id,
                              },
                              {
                                indexs: ["riwayat_pekerjaan", "unit_id"],
                                val: null,
                              },
                            ],
                            "gajis",
                            "jml_tdk_hadir",
                          )
                        }}
                      </td>

                      <td style="border: 1px solid #000; font-weight: bold">
                        {{
                          getSums(
                            [
                              {
                                indexs: ["riwayat_pekerjaan", "cabang_id"],
                                val: cabang.id,
                              },
                              {
                                indexs: ["riwayat_pekerjaan", "unit_id"],
                                val: null,
                              },
                            ],
                            "gajis",
                            "pot_5_persen",
                          )
                        }}
                      </td>

                      <td style="border: 1px solid #000; font-weight: bold">
                        {{
                          getSums(
                            [
                              {
                                indexs: ["riwayat_pekerjaan", "cabang_id"],
                                val: cabang.id,
                              },
                              {
                                indexs: ["riwayat_pekerjaan", "unit_id"],
                                val: null,
                              },
                            ],
                            "gajis",
                            "jml_bruto",
                          )
                        }}
                      </td>

                      <td style="border: 1px solid #000; font-weight: bold">
                        {{
                          getSums(
                            [
                              {
                                indexs: ["riwayat_pekerjaan", "cabang_id"],
                                val: cabang.id,
                              },
                              {
                                indexs: ["riwayat_pekerjaan", "unit_id"],
                                val: null,
                              },
                            ],
                            "gajis",
                            "tun_pph",
                          )
                        }}
                      </td>
                      <td style="border: 1px solid #000; font-weight: bold">
                        {{
                          getSumsColJml(
                            [
                              {
                                indexs: ["riwayat_pekerjaan", "cabang_id"],
                                val: cabang.id,
                              },
                              {
                                indexs: ["riwayat_pekerjaan", "unit_id"],
                                val: null,
                              },
                            ],
                            "gajis",
                          )
                        }}
                      </td>
                      <td style="border: 1px solid #000; font-weight: bold">
                        {{
                          getSums(
                            [
                              {
                                indexs: ["riwayat_pekerjaan", "cabang_id"],
                                val: cabang.id,
                              },
                              {
                                indexs: ["riwayat_pekerjaan", "unit_id"],
                                val: null,
                              },
                            ],
                            "gajis",
                            "pot_kesehatan",
                          )
                        }}
                      </td>
                      <td style="border: 1px solid #000; font-weight: bold">
                        {{
                          getSums(
                            [
                              {
                                indexs: ["riwayat_pekerjaan", "cabang_id"],
                                val: cabang.id,
                              },
                              {
                                indexs: ["riwayat_pekerjaan", "unit_id"],
                                val: null,
                              },
                            ],
                            "gajis",
                            "pot_bpjs_tk_tiga_program",
                          )
                        }}
                      </td>
                      <td style="border: 1px solid #000; font-weight: bold">
                        {{
                          getSums(
                            [
                              {
                                indexs: ["riwayat_pekerjaan", "cabang_id"],
                                val: cabang.id,
                              },
                              {
                                indexs: ["riwayat_pekerjaan", "unit_id"],
                                val: null,
                              },
                            ],
                            "gajis",
                            "pot_bpjs_tk_empat_program",
                          )
                        }}
                      </td>
                      <td style="border: 1px solid #000; font-weight: bold">
                        {{
                          getSums(
                            [
                              {
                                indexs: ["riwayat_pekerjaan", "cabang_id"],
                                val: cabang.id,
                              },
                              {
                                indexs: ["riwayat_pekerjaan", "unit_id"],
                                val: null,
                              },
                            ],
                            "gajis",
                            "pot_pensiun",
                          )
                        }}
                      </td>
                      <td style="border: 1px solid #000; font-weight: bold">
                        {{
                          getSums(
                            [
                              {
                                indexs: ["riwayat_pekerjaan", "cabang_id"],
                                val: cabang.id,
                              },
                              {
                                indexs: ["riwayat_pekerjaan", "unit_id"],
                                val: null,
                              },
                            ],
                            "gajis",
                            "ifg_mandiri",
                          )
                        }}
                      </td>
                      <td style="border: 1px solid #000; font-weight: bold">
                        {{
                          getSums(
                            [
                              {
                                indexs: ["riwayat_pekerjaan", "cabang_id"],
                                val: cabang.id,
                              },
                              {
                                indexs: ["riwayat_pekerjaan", "unit_id"],
                                val: null,
                              },
                            ],
                            "gajis",
                            "pot_pph",
                          )
                        }}
                      </td>
                      <td style="border: 1px solid #000; font-weight: bold">
                        {{
                          getSums(
                            [
                              {
                                indexs: ["riwayat_pekerjaan", "cabang_id"],
                                val: cabang.id,
                              },
                              {
                                indexs: ["riwayat_pekerjaan", "unit_id"],
                                val: null,
                              },
                            ],
                            "gajis",
                            "total_diterima",
                          )
                        }}
                      </td>
                      <td
                        style="border: 1px solid #000"
                        class="bottom-text"
                      ></td>
                      <td class="bottom-text"></td>
                    </tr>

                    <!-- <tr></tr> -->
                  </table>
                  <div class="row arial12" v-if="gajis">
                    <div class="col-12">
                      <p>
                        Terbilang : -----
                        {{
                          formatNumberTerbilang(
                            getSumsColJml(
                              [
                                {
                                  indexs: ["riwayat_pekerjaan", "cabang_id"],
                                  val: cabang.id,
                                },
                                {
                                  indexs: ["riwayat_pekerjaan", "unit_id"],
                                  val: null,
                                },
                              ],
                              "gajis",
                            ),
                          )
                        }}
                        Rupiah -----
                      </p>
                    </div>
                    <div class="row" style="text-align: center">
                      <div class="col-4">
                        Perumda Air Minum <br />
                        Tirta Hita Buleleng <br />
                        Mengetahui: <br />
                        <br />

                        <div
                          style="text-decoration: underline; padding-top: 35px"
                          v-if="pejabat.dirum"
                        >
                          {{ pejabat.dirum.nama }}
                        </div>

                        Direktur Umum
                      </div>
                      <div class="col-4">
                        <br />
                        <br />

                        Diperiksa:<br />
                        <br />

                        <!-- <div
                          style="text-decoration: underline; padding-top: 35px"
                          v-if="pejabatMengetahui"
                        >
                          {{ pejabatMengetahui.nama }}
                        </div>
                        Kepala Bagian Umum -->
                        <div
                          style="text-decoration: underline; padding-top: 35px"
                          v-if="pejabat.pejabatMengetahui"
                        >
                          {{ pejabat.pejabatMengetahui.nama }}
                        </div>
                        <div v-if="pejabat.pejabatMengetahui">
                          {{ pejabat.pejabatMengetahui.jabatan }}
                        </div>
                      </div>
                      <div class="col-4">
                        <br />

                        Singaraja,
                        {{ this.pejabatMembuatTgl }}
                        <br />

                        Dibuat Oleh:<br />
                        <br />

                        <div
                          style="text-decoration: underline; padding-top: 35px"
                          v-if="pejabat.pejabatMembuat"
                        >
                          {{ pejabat.pejabatMembuat.nama }}
                        </div>
                        <div v-if="pejabat.pejabatMembuat">
                          {{ pejabat.pejabatMembuat.jabatan }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- /col-12  -->
        </div>

        <!-- /bagians-->
      </div>
      <!-- /cabangs end of cabang > 1-->
    </div>
    <!-- /v-for cabangs -->

    <div v-for="unit in units" :key="unit.id">
      <div class="row add-page-break-after">
        <div class="col-12">
          <div class="p-3 mb-3">
            <div class="row">
              <div class="col-12">
                <h5
                  style="
                    font-weight: bold;
                    font-family: Arial, sans-serif;
                    font-size: 12px;
                  "
                >
                  PERUSAHAAN UMUM DAERAH AIR MINUM
                </h5>
                <h5
                  style="
                    font-weight: bold;
                    font-family: Arial, sans-serif;
                    font-size: 12px;
                  "
                >
                  TIRTA HITA BULELENG
                </h5>
                <h4 class="header-title">
                  <strong
                    >DAFTAR PEMBAYARAN GAJI CABANG
                    {{ toUpper(unit.cabang.nama) }} UNIT
                    {{ toUpper(unit.nama) }}
                  </strong>
                </h4>
                <h5 class="header-periode" style="padding-bottom: 20px">
                  <strong
                    >UNTUK BULAN: {{ printBulanNama() }}
                    {{ printTahun() }}</strong
                  >
                </h5>

                <table class="table" v-if="gajis">
                  <thead>
                    <tr class="center-top-text">
                      <th rowspan="3">NO</th>
                      <th rowspan="3" style="min-width: 120px">
                        NAMA<br />
                        <br />NIP/NIK<br />JABATAN
                      </th>
                      <th rowspan="3" colspan="2" style="width: 3%">GOL.</th>
                      <th rowspan="2">GAJI<br />POKOK</th>
                      <th colspan="9" rowspan="1">TUNJANGAN</th>
                      <th colspan="2" rowspan="1">POT. KETIDAKHADIRAN</th>
                      <th rowspan="2">
                        JUMLAH<br />
                        BRUTO
                      </th>
                      <th rowspan="2">TUNJANGAN<br />PPH</th>
                      <th rowspan="2">JUMLAH<br />(15+16)</th>
                      <th rowspan="1" colspan="6">POTONGAN</th>
                      <th rowspan="2">JUMLAH<br />DITERIMA</th>
                      <th rowspan="3" style="width: 2%" class="no-right-border">
                        &nbsp;
                      </th>
                      <th rowspan="3">TANDA TANGAN</th>
                    </tr>

                    <tr class="center-top-text">
                      <th style="width: 5%">
                        PERUSAHAAN
                        <div class="small-text">(5)x 25%</div>
                      </th>
                      <th>JABATAN</th>
                      <th>
                        KEMAHALAN
                        <div class="small-text">(5)x 5%</div>
                      </th>
                      <th>AIR</th>
                      <th>TRANSPORT</th>
                      <th>PANGAN</th>
                      <th>KESEHATAN</th>
                      <th>PREMI JKK</th>
                      <th>PREMI JKM</th>
                      <th>HARI</th>
                      <th>
                        JUMLAH
                        <div class="small-text">13X5%(6+10)</div>
                      </th>
                      <th>KESEHATAN</th>
                      <th>
                        BPJS TK<br />3 PROGRAM
                        <div class="small-text">(15)X2%</div>
                      </th>
                      <th>
                        BPJS TK<br />4 PROGRAM
                        <div class="small-text">(15)X3%</div>
                      </th>
                      <th>PENSIUN<br />IFG LIFE</th>
                      <th>IFG<br />MANDIRI</th>
                      <th>PPH<br />PASAL 21</th>
                    </tr>

                    <tr class="center-top-text">
                      <th style="border: none">(Rp.)</th>
                      <th>(Rp.)</th>
                      <th>(Rp.)</th>
                      <th>(Rp.)</th>
                      <th>(Rp.)</th>
                      <th>(Rp.)</th>
                      <th>(Rp.)</th>
                      <th>(Rp.)</th>
                      <th>(Rp.)</th>

                      <th>(Rp.)</th>
                      <th></th>
                      <th>(Rp.)</th>
                      <th>(Rp.)</th>
                      <th>(Rp.)</th>
                      <th>(Rp.)</th>
                      <th>(Rp.)</th>
                      <th>(Rp.)</th>
                      <th>(Rp.)</th>
                      <th>(Rp.)</th>
                      <th>(Rp.)</th>
                      <th>(Rp.)</th>
                      <th>(Rp.)</th>
                    </tr>
                    <tr class="center-top-text">
                      <th>1</th>
                      <th>2</th>
                      <th>3</th>
                      <th>4</th>
                      <th>5</th>
                      <th>6</th>
                      <th>7</th>
                      <th>8</th>
                      <th>9</th>
                      <th>10</th>
                      <th>11</th>
                      <th>12</th>
                      <th>13</th>
                      <th>14</th>
                      <th>15</th>
                      <th>16</th>
                      <th>17</th>
                      <th>18</th>
                      <th>19</th>
                      <th>20</th>
                      <th>21</th>
                      <th>22</th>
                      <th>23</th>
                      <th>24</th>
                      <th>25</th>
                      <th>26</th>
                      <th></th>
                      <th>27</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="(item, index) in filterGajisByConditions(
                        [
                          {
                            indexs: ['riwayat_pekerjaan', 'unit_id'],
                            val: unit.id,
                          },
                        ],
                        'seksis_order',
                        'gajis',
                      )"
                      :key="item.id"
                      :class="getPageBreakStyle(index)"
                    >
                      <td style="border: 1px solid #000">
                        <span
                          :style="printNewLine(item.print_sub_bagian)"
                          v-if="subBagians"
                        >
                        </span>
                        {{ index + 1 }}
                      </td>
                      <td style="border: 1px solid #000">
                        <div :style="boldStyle">
                          <!-- v-if="shouldRenderSubBagian" -->
                          {{
                            printSubBagian(
                              item.print_sub_bagian,
                              item.riwayat_pekerjaan,
                            )
                          }}
                        </div>
                        {{ item.pegawai.nama }}
                        <br />NIK.
                        {{ item.pegawai.nik }}
                      </td>
                      <td style="border: 1px solid #000">
                        <span :style="printNewLine(item.print_sub_bagian)">
                        </span>
                        {{ item.golongan.nama }}
                      </td>

                      <td style="border: 1px solid #000">
                        <span :style="printNewLine(item.print_sub_bagian)">
                        </span>
                        <!-- {{ item.pegawai.status_ptkp }} -->
                        {{ item.pph ? item.pph.ptkp : "" }}
                      </td>

                      <td style="border: 1px solid #000">
                        <span :style="printNewLine(item.print_sub_bagian)">
                        </span>
                        {{ formatNumber(item.gaji_pokok) }}
                      </td>

                      <td style="border: 1px solid #000">
                        <span :style="printNewLine(item.print_sub_bagian)">
                        </span>
                        {{ formatNumber(item.tun_perusahaan) }}
                      </td>

                      <td style="border: 1px solid #000">
                        <span :style="printNewLine(item.print_sub_bagian)">
                        </span>
                        {{ formatNumber(item.tun_jabatan) }}
                      </td>

                      <td style="border: 1px solid #000">
                        <span :style="printNewLine(item.print_sub_bagian)">
                        </span>
                        {{ formatNumber(item.tun_kemahalan) }}
                      </td>

                      <td style="border: 1px solid #000">
                        <span :style="printNewLine(item.print_sub_bagian)">
                        </span>
                        {{ formatNumber(item.tun_air) }}
                      </td>

                      <td style="border: 1px solid #000">
                        <span :style="printNewLine(item.print_sub_bagian)">
                        </span>
                        {{ formatNumber(item.tun_transport) }}
                      </td>

                      <td style="border: 1px solid #000">
                        <span :style="printNewLine(item.print_sub_bagian)">
                        </span>
                        {{ formatNumber(item.tun_pangan) }}
                      </td>

                      <td style="border: 1px solid #000">
                        <span :style="printNewLine(item.print_sub_bagian)">
                        </span>
                        {{ formatNumber(item.tun_kesehatan) }}
                      </td>
                      <td style="border: 1px solid #000">
                        <span :style="printNewLine(item.print_sub_bagian)">
                        </span>
                        {{ formatNumber(item.premi_jkk) }}
                      </td>
                      <td style="border: 1px solid #000">
                        <span :style="printNewLine(item.print_sub_bagian)">
                        </span>
                        {{ formatNumber(item.premi_jkm) }}
                      </td>

                      <td style="border: 1px solid #000">
                        <span :style="printNewLine(item.print_sub_bagian)">
                        </span>
                        {{ formatNumber(item.jml_tdk_hadir) }}
                      </td>

                      <td style="border: 1px solid #000">
                        <span :style="printNewLine(item.print_sub_bagian)">
                        </span>
                        {{ formatNumber(item.pot_5_persen) }}
                      </td>

                      <td style="border: 1px solid #000">
                        <span :style="printNewLine(item.print_sub_bagian)">
                        </span>
                        {{ formatNumber(item.jml_bruto) }}
                      </td>

                      <td style="border: 1px solid #000">
                        <span :style="printNewLine(item.print_sub_bagian)">
                        </span>
                        {{ formatNumber(item.tun_pph) }}
                      </td>
                      <td style="border: 1px solid #000">
                        <span :style="printNewLine(item.print_sub_bagian)">
                        </span>
                        {{ formatNumber(item.tun_pph + item.jml_bruto) }}
                      </td>
                      <td style="border: 1px solid #000">
                        <span :style="printNewLine(item.print_sub_bagian)">
                        </span>
                        {{ formatNumber(item.pot_kesehatan) }}
                      </td>
                      <td style="border: 1px solid #000">
                        <span :style="printNewLine(item.print_sub_bagian)">
                        </span>
                        {{ formatNumber(item.pot_bpjs_tk_tiga_program) }}
                      </td>
                      <td style="border: 1px solid #000">
                        <span :style="printNewLine(item.print_sub_bagian)">
                        </span>
                        {{ formatNumber(item.pot_bpjs_tk_empat_program) }}
                      </td>
                      <td style="border: 1px solid #000">
                        <span :style="printNewLine(item.print_sub_bagian)">
                        </span>
                        {{ formatNumber(item.pot_pensiun) }}
                      </td>
                      <td style="border: 1px solid #000">
                        <span :style="printNewLine(item.print_sub_bagian)">
                        </span>
                        {{ formatNumber(item.ifg_mandiri) }}
                      </td>
                      <td style="border: 1px solid #000">
                        <span :style="printNewLine(item.print_sub_bagian)">
                        </span>
                        {{ formatNumber(item.pot_pph) }}
                      </td>
                      <td style="border: 1px solid #000">
                        <span :style="printNewLine(item.print_sub_bagian)">
                        </span>
                        {{ formatNumber(item.total_diterima) }}
                      </td>
                      <td style="border: 1px solid #000" class="bottom-text">
                        <span :style="printNewLine(item.print_sub_bagian)">
                        </span>
                        {{ index + 1 }}
                      </td>
                      <td class="bottom-text">
                        <span :style="printNewLine(item.print_sub_bagian)">
                        </span
                        >...............
                      </td>
                    </tr>
                  </tbody>

                  <tr class="top-text table-row-vfor" v-if="gajis.totalGajis">
                    <td style="border: 1px solid #000"></td>
                    <td style="border: 1px solid #000; font-weight: bold">
                      JUMLAH
                    </td>
                    <td style="border: 1px solid #000"></td>
                    <td style="border: 1px solid #000"></td>

                    <td style="border: 1px solid #000; font-weight: bold">
                      {{
                        getSums(
                          [
                            {
                              indexs: ["riwayat_pekerjaan", "unit_id"],
                              val: unit.id,
                            },
                          ],
                          "gajis",
                          "gaji_pokok",
                        )
                      }}
                    </td>

                    <td style="border: 1px solid #000; font-weight: bold">
                      {{
                        getSums(
                          [
                            {
                              indexs: ["riwayat_pekerjaan", "unit_id"],
                              val: unit.id,
                            },
                          ],
                          "gajis",
                          "tun_perusahaan",
                        )
                      }}
                    </td>

                    <td style="border: 1px solid #000; font-weight: bold">
                      {{
                        getSums(
                          [
                            {
                              indexs: ["riwayat_pekerjaan", "unit_id"],
                              val: unit.id,
                            },
                          ],
                          "gajis",
                          "tun_jabatan",
                        )
                      }}
                    </td>

                    <td style="border: 1px solid #000; font-weight: bold">
                      {{
                        getSums(
                          [
                            {
                              indexs: ["riwayat_pekerjaan", "unit_id"],
                              val: unit.id,
                            },
                          ],
                          "gajis",
                          "tun_kemahalan",
                        )
                      }}
                    </td>

                    <td style="border: 1px solid #000; font-weight: bold">
                      {{
                        getSums(
                          [
                            {
                              indexs: ["riwayat_pekerjaan", "unit_id"],
                              val: unit.id,
                            },
                          ],
                          "gajis",
                          "tun_air",
                        )
                      }}
                    </td>

                    <td style="border: 1px solid #000; font-weight: bold">
                      {{
                        getSums(
                          [
                            {
                              indexs: ["riwayat_pekerjaan", "unit_id"],
                              val: unit.id,
                            },
                          ],
                          "gajis",
                          "tun_transport",
                        )
                      }}
                    </td>

                    <td style="border: 1px solid #000; font-weight: bold">
                      {{
                        getSums(
                          [
                            {
                              indexs: ["riwayat_pekerjaan", "unit_id"],
                              val: unit.id,
                            },
                          ],
                          "gajis",
                          "tun_pangan",
                        )
                      }}
                    </td>

                    <td style="border: 1px solid #000; font-weight: bold">
                      {{
                        getSums(
                          [
                            {
                              indexs: ["riwayat_pekerjaan", "unit_id"],
                              val: unit.id,
                            },
                          ],
                          "gajis",
                          "tun_kesehatan",
                        )
                      }}
                    </td>
                    <td style="border: 1px solid #000; font-weight: bold">
                      {{
                        getSums(
                          [
                            {
                              indexs: ["riwayat_pekerjaan", "unit_id"],
                              val: unit.id,
                            },
                          ],
                          "gajis",
                          "premi_jkk",
                        )
                      }}
                    </td>
                    <td style="border: 1px solid #000; font-weight: bold">
                      {{
                        getSums(
                          [
                            {
                              indexs: ["riwayat_pekerjaan", "unit_id"],
                              val: unit.id,
                            },
                          ],
                          "gajis",
                          "premi_jkm",
                        )
                      }}
                    </td>

                    <td style="border: 1px solid #000; font-weight: bold">
                      {{
                        getSums(
                          [
                            {
                              indexs: ["riwayat_pekerjaan", "unit_id"],
                              val: unit.id,
                            },
                          ],
                          "gajis",
                          "jml_tdk_hadir",
                        )
                      }}
                    </td>

                    <td style="border: 1px solid #000; font-weight: bold">
                      {{
                        getSums(
                          [
                            {
                              indexs: ["riwayat_pekerjaan", "unit_id"],
                              val: unit.id,
                            },
                          ],
                          "gajis",
                          "pot_5_persen",
                        )
                      }}
                    </td>

                    <td style="border: 1px solid #000; font-weight: bold">
                      {{
                        getSums(
                          [
                            {
                              indexs: ["riwayat_pekerjaan", "unit_id"],
                              val: unit.id,
                            },
                          ],
                          "gajis",
                          "jml_bruto",
                        )
                      }}
                    </td>

                    <td style="border: 1px solid #000; font-weight: bold">
                      {{
                        getSums(
                          [
                            {
                              indexs: ["riwayat_pekerjaan", "unit_id"],
                              val: unit.id,
                            },
                          ],
                          "gajis",
                          "tun_pph",
                        )
                      }}
                    </td>
                    <td style="border: 1px solid #000; font-weight: bold">
                      {{
                        getSumsColJml(
                          [
                            {
                              indexs: ["riwayat_pekerjaan", "unit_id"],
                              val: unit.id,
                            },
                          ],
                          "gajis",
                        )
                      }}
                    </td>
                    <td style="border: 1px solid #000; font-weight: bold">
                      {{
                        getSums(
                          [
                            {
                              indexs: ["riwayat_pekerjaan", "unit_id"],
                              val: unit.id,
                            },
                          ],
                          "gajis",
                          "pot_kesehatan",
                        )
                      }}
                    </td>
                    <td style="border: 1px solid #000; font-weight: bold">
                      {{
                        getSums(
                          [
                            {
                              indexs: ["riwayat_pekerjaan", "unit_id"],
                              val: unit.id,
                            },
                          ],
                          "gajis",
                          "pot_bpjs_tk_tiga_program",
                        )
                      }}
                    </td>
                    <td style="border: 1px solid #000; font-weight: bold">
                      {{
                        getSums(
                          [
                            {
                              indexs: ["riwayat_pekerjaan", "unit_id"],
                              val: unit.id,
                            },
                          ],
                          "gajis",
                          "pot_bpjs_tk_empat_program",
                        )
                      }}
                    </td>
                    <td style="border: 1px solid #000; font-weight: bold">
                      {{
                        getSums(
                          [
                            {
                              indexs: ["riwayat_pekerjaan", "unit_id"],
                              val: unit.id,
                            },
                          ],
                          "gajis",
                          "pot_pensiun",
                        )
                      }}
                    </td>
                    <td style="border: 1px solid #000; font-weight: bold">
                      {{
                        getSums(
                          [
                            {
                              indexs: ["riwayat_pekerjaan", "unit_id"],
                              val: unit.id,
                            },
                          ],
                          "gajis",
                          "ifg_mandiri",
                        )
                      }}
                    </td>
                    <td style="border: 1px solid #000; font-weight: bold">
                      {{
                        getSums(
                          [
                            {
                              indexs: ["riwayat_pekerjaan", "unit_id"],
                              val: unit.id,
                            },
                          ],
                          "gajis",
                          "pot_pph",
                        )
                      }}
                    </td>
                    <td style="border: 1px solid #000; font-weight: bold">
                      {{
                        getSums(
                          [
                            {
                              indexs: ["riwayat_pekerjaan", "unit_id"],
                              val: unit.id,
                            },
                          ],
                          "gajis",
                          "total_diterima",
                        )
                      }}
                    </td>
                    <td style="border: 1px solid #000" class="bottom-text"></td>
                    <td class="bottom-text"></td>
                  </tr>
                  <!-- <tr></tr> -->
                </table>
                <div class="row arial12" v-if="gajis">
                  <div class="col-12">
                    <p>
                      Terbilang : -----
                      {{
                        formatNumberTerbilang(
                          getSumsColJml(
                            [
                              {
                                indexs: ["riwayat_pekerjaan", "unit_id"],
                                val: unit.id,
                              },
                            ],
                            "gajis",
                          ),
                        )
                      }}
                      Rupiah -----
                    </p>
                  </div>
                  <div class="row" style="text-align: center">
                    <div class="col-4">
                      Perumda Air Minum <br />
                      Tirta Hita Buleleng <br />
                      Mengetahui: <br />
                      <br />

                      <div
                        style="text-decoration: underline; padding-top: 35px"
                        v-if="pejabat.dirum"
                      >
                        {{ pejabat.dirum.nama }}
                      </div>

                      Direktur Umum
                    </div>
                    <div class="col-4">
                      <br />
                      <br />

                      Diperiksa:<br />
                      <br />

                      <!-- <div
                        style="text-decoration: underline; padding-top: 35px"
                        v-if="pejabatMengetahui"
                      >
                        {{ pejabatMengetahui.nama }}
                      </div>
                      Kepala Bagian Umum -->
                      <div
                        style="text-decoration: underline; padding-top: 35px"
                        v-if="pejabat.pejabatMengetahui"
                      >
                        {{ pejabat.pejabatMengetahui.nama }}
                      </div>
                      <div v-if="pejabat.pejabatMengetahui">
                        {{ pejabat.pejabatMengetahui.jabatan }}
                      </div>
                    </div>
                    <div class="col-4">
                      <br />

                      Singaraja,
                      {{ this.pejabatMembuatTgl }}
                      <br />

                      Dibuat Oleh:<br />
                      <br />

                      <div
                        style="text-decoration: underline; padding-top: 35px"
                        v-if="pejabat.pejabatMembuat"
                      >
                        {{ pejabat.pejabatMembuat.nama }}
                      </div>
                      <div v-if="pejabat.pejabatMembuat">
                        {{ pejabat.pejabatMembuat.jabatan }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- /col-12  -->
      </div>
    </div>
    <!-- /units-->

    <!-- //////////////////////////////START OF HONOR ///////////////////////////////////////////// -->

    <div v-if="gajisHonor">
      <div
        v-for="(cabang, cabangIndex) in cabangs"
        :key="cabang.id"
        style="margin-bottom: 0px"
      >
        <div
          v-if="
            shouldPrintGaji(
              [
                {
                  indexs: ['riwayat_pekerjaan', 'cabang_id'],
                  val: cabang.id,
                },
                {
                  indexs: ['riwayat_pekerjaan', 'unit_id'],
                  val: null,
                },
              ],
              'gajisHonor',
            ) !== 'skip'
          "
        >
          <!-- variable: {{ getGlobalVariable }} -->
          <!-- Index: {{ indexTableHonor }} -->
          <!-- <span v-if="incrementIndexTableHonor()"></span> -->
          <div class="row add-page-break-before">
            <div class="col-12">
              <div class="p-3 mb-3">
                <div class="row">
                  <div class="col-12">
                    <h4 class="header-title">
                      <strong
                        >GAJI/UPAH TENAGA KONTRAK KANTOR
                        {{ toUpper(cabang.nama) }}
                      </strong>
                    </h4>
                    <h5 class="header-periode" style="padding-bottom: 20px">
                      <strong
                        >UNTUK BULAN: {{ printBulanNama() }}
                        {{ printTahun() }}</strong
                      >
                    </h5>

                    <table class="table">
                      <thead>
                        <tr class="center-top-text">
                          <th rowspan="3">NO</th>
                          <th rowspan="3">NAMA</th>
                          <th rowspan="3">GOL.</th>
                          <th rowspan="3">JABATAN</th>
                          <th rowspan="3">MASA KERJA</th>
                          <th rowspan="3">TMT<br />KONTRAK</th>
                          <th rowspan="2">UPAH (UMK)</th>
                          <th rowspan="2">
                            TAMB. UPAH<br />MASA KERJA
                            <div class="small-text">(MK x 3% x UMK)</div>
                          </th>
                          <th rowspan="2">TUNJ. <br />KESEHATAN</th>
                          <th rowspan="2">TUNJ.<br />PREMI<br />JKK</th>
                          <th rowspan="2">TUNJ.<br />PREMI<br />JKM</th>
                          <th rowspan="3">JML <br />TIDAK<br />MASUK</th>
                          <th rowspan="2">
                            POT.<br />KETIDAKHADIRAN
                            <div class="small-text">(2%x6)9</div>
                          </th>
                          <th rowspan="2">JUMLAH <br />BRUTO</th>
                          <th rowspan="1" colspan="3">POTONGAN</th>
                          <th rowspan="2">GAJI/UPAH <br />DITERIMA</th>
                          <th rowspan="3" colspan="2">TANDA<br />TANGAN</th>
                        </tr>

                        <tr class="center-top-text">
                          <th>KESEHATAN</th>
                          <th>
                            BPJS TK
                            <div class="small-text">(9)x2%</div>
                          </th>
                          <th>IFG LIFE<br />MANDIRI</th>
                        </tr>

                        <tr class="center-top-text">
                          <th style="border: none">(Rp.)</th>
                          <th>(Rp.)</th>
                          <th>(Rp.)</th>
                          <th>(Rp.)</th>
                          <th>(Rp.)</th>
                          <th>(Rp.)</th>
                          <th>(Rp.)</th>
                          <th>(Rp.)</th>
                          <th>(Rp.)</th>
                          <th>(Rp.)</th>
                          <th>(Rp.)</th>
                        </tr>
                        <tr class="center-top-text">
                          <th>1</th>
                          <th>2</th>
                          <th>3</th>
                          <th>4</th>
                          <th>5</th>
                          <th>6</th>
                          <th>7</th>
                          <th>8</th>
                          <th>9</th>
                          <th>9</th>
                          <th>10</th>
                          <th>11</th>
                          <th>12</th>
                          <th>13</th>
                          <th>14</th>
                          <th>15</th>
                          <th>16</th>
                          <th>17</th>
                          <th></th>
                          <th>19</th>
                        </tr>
                      </thead>

                      <tbody>
                        <tr
                          v-for="(item, index) in filterGajisByConditions(
                            [
                              {
                                indexs: ['riwayat_pekerjaan', 'cabang_id'],
                                val: cabang.id,
                              },
                              // {
                              //   indexs: ['riwayat_pekerjaan', 'unit_id'],
                              //   val: null,
                              // },
                            ],
                            '',
                            'gajisHonor',
                          )"
                          :key="item.id"
                          :class="getPageBreakStyleHonorKontrak(index)"
                        >
                          <!-- :class="'top-text table-row-vfor'"
                            :style="getPageBreakStyle(index)" -->
                          <td
                            style="border: 1px solid #000; text-align: center"
                            :ref="'refTdHonor-' + cabangIndex + '-' + index"
                          >
                            {{ printRefTdHonor(cabangIndex, index) }}
                          </td>
                          <td style="border: 1px solid #000">
                            <!-- {{ item.pegawai.nama }} -->
                            {{ item.pegawai.nama }}
                          </td>
                          <td
                            style="border: 1px solid #000; text-align: center"
                          >
                            <!-- {{ item.golongan.nama }} PERBAIKI GAJI YAA KARENA JUNI TIDAK ADA GOLONGAN_ID-->
                            {{ printGolKontrak(item.golongan.nama) }}
                          </td>

                          <td style="border: 1px solid #000">
                            <div v-if="shouldRenderSubBagian">
                              {{
                                printJabatanHonorKontrak(item.riwayat_pekerjaan)
                              }}
                            </div>
                          </td>

                          <td style="border: 1px solid #000">
                            {{ item.masa_kerja }} tahun
                          </td>

                          <td style="border: 1px solid #000">
                            {{
                              convertTglFormat(item.pegawai.tgl_mulai_bekerja)
                            }}
                          </td>

                          <td style="border: 1px solid #000">
                            {{ formatNumber(item.honor_umk_jml) }}
                          </td>

                          <td style="border: 1px solid #000">
                            {{ formatNumber(item.kenaikan_masa_kerja) }}
                          </td>

                          <td style="border: 1px solid #000">
                            {{ formatNumber(item.tun_kesehatan) }}
                          </td>
                          <td style="border: 1px solid #000">
                            {{ formatNumber(item.premi_jkk) }}
                          </td>
                          <td style="border: 1px solid #000">
                            {{ formatNumber(item.premi_jkm) }}
                          </td>

                          <td style="border: 1px solid #000">
                            {{ formatNumber(item.jml_tdk_hadir) }}
                          </td>

                          <td style="border: 1px solid #000">
                            {{ formatNumber(item.pot_5_persen) }}
                          </td>

                          <td style="border: 1px solid #000">
                            {{ formatNumber(item.jml_bruto) }}
                          </td>

                          <td style="border: 1px solid #000">
                            {{ formatNumber(item.pot_kesehatan) }}
                          </td>

                          <td style="border: 1px solid #000">
                            {{ formatNumber(item.pot_bpjs_tk_dua_persen) }}
                          </td>
                          <td style="border: 1px solid #000">
                            {{ formatNumber(item.ifg_mandiri) }}
                          </td>

                          <td style="border: 1px solid #000">
                            {{ formatNumber(item.total_diterima) }}
                          </td>

                          <td
                            style="border: 1px solid #000"
                            class="bottom-text"
                            :ref="'refTdHonorTTD-' + cabangIndex + '-' + index"
                          >
                            {{ printRefTdHonorTTD(cabangIndex, index) }}
                          </td>
                          <td class="bottom-text">...............</td>
                        </tr>
                      </tbody>
                      <tr
                        class="top-text table-row-vfor"
                        v-if="gajisHonor.totalGajis"
                      >
                        <td
                          style="
                            border: 1px solid #000;
                            font-weight: bold;
                            text-align: center;
                          "
                          colspan="4"
                        >
                          JUMLAH
                          <!-- increment {{ incrementIndexTableHonor() }} -->
                          <!-- <span
                            v-for="index in cabangs.length"
                            :key="index"
                            style="margin-right: 1px"
                          >
                            {{ index }}
                          </span> -->
                          <!-- {{ commonFunction.convertToRoman(indexTableHonor) }} -->
                          <!-- {{ incrementTableHonor() }} -->
                        </td>
                        <td style="border: 1px solid #000"></td>
                        <td style="border: 1px solid #000"></td>

                        <td style="border: 1px solid #000; font-weight: bold">
                          {{
                            getSums(
                              [
                                {
                                  indexs: ["riwayat_pekerjaan", "cabang_id"],
                                  val: cabang.id,
                                },
                                // {
                                //   indexs: ["riwayat_pekerjaan", "unit_id"],
                                //   val: null,
                                // },
                              ],
                              "gajisHonor",
                              "honor_umk_jml",
                            )
                          }}
                        </td>

                        <td style="border: 1px solid #000; font-weight: bold">
                          {{
                            getSums(
                              [
                                {
                                  indexs: ["riwayat_pekerjaan", "cabang_id"],
                                  val: cabang.id,
                                },
                                {
                                  indexs: ["riwayat_pekerjaan", "unit_id"],
                                  val: null,
                                },
                              ],
                              "gajisHonor",
                              "kenaikan_masa_kerja",
                            )
                          }}
                        </td>

                        <td style="border: 1px solid #000; font-weight: bold">
                          {{
                            getSums(
                              [
                                {
                                  indexs: ["riwayat_pekerjaan", "cabang_id"],
                                  val: cabang.id,
                                },
                                {
                                  indexs: ["riwayat_pekerjaan", "unit_id"],
                                  val: null,
                                },
                              ],
                              "gajisHonor",
                              "tun_kesehatan",
                            )
                          }}
                        </td>

                        <td style="border: 1px solid #000; font-weight: bold">
                          {{
                            getSums(
                              [
                                {
                                  indexs: ["riwayat_pekerjaan", "cabang_id"],
                                  val: cabang.id,
                                },
                                {
                                  indexs: ["riwayat_pekerjaan", "unit_id"],
                                  val: null,
                                },
                              ],
                              "gajisHonor",
                              "premi_jkk",
                            )
                          }}
                        </td>

                        <td style="border: 1px solid #000; font-weight: bold">
                          {{
                            getSums(
                              [
                                {
                                  indexs: ["riwayat_pekerjaan", "cabang_id"],
                                  val: cabang.id,
                                },
                                {
                                  indexs: ["riwayat_pekerjaan", "unit_id"],
                                  val: null,
                                },
                              ],
                              "gajisHonor",
                              "premi_jkm",
                            )
                          }}
                        </td>

                        <td style="border: 1px solid #000; font-weight: bold">
                          {{
                            getSums(
                              [
                                {
                                  indexs: ["riwayat_pekerjaan", "cabang_id"],
                                  val: cabang.id,
                                },
                                {
                                  indexs: ["riwayat_pekerjaan", "unit_id"],
                                  val: null,
                                },
                              ],
                              "gajisHonor",
                              "jml_tdk_hadir",
                            )
                          }}
                        </td>

                        <td style="border: 1px solid #000; font-weight: bold">
                          {{
                            getSums(
                              [
                                {
                                  indexs: ["riwayat_pekerjaan", "cabang_id"],
                                  val: cabang.id,
                                },
                                {
                                  indexs: ["riwayat_pekerjaan", "unit_id"],
                                  val: null,
                                },
                              ],
                              "gajisHonor",
                              "pot_5_persen",
                            )
                          }}
                        </td>

                        <td style="border: 1px solid #000; font-weight: bold">
                          {{
                            getSums(
                              [
                                {
                                  indexs: ["riwayat_pekerjaan", "cabang_id"],
                                  val: cabang.id,
                                },
                                {
                                  indexs: ["riwayat_pekerjaan", "unit_id"],
                                  val: null,
                                },
                              ],
                              "gajisHonor",
                              "jml_bruto",
                            )
                          }}
                        </td>

                        <td style="border: 1px solid #000; font-weight: bold">
                          {{
                            getSums(
                              [
                                {
                                  indexs: ["riwayat_pekerjaan", "cabang_id"],
                                  val: cabang.id,
                                },
                                {
                                  indexs: ["riwayat_pekerjaan", "unit_id"],
                                  val: null,
                                },
                              ],
                              "gajisHonor",
                              "pot_kesehatan",
                            )
                          }}
                        </td>

                        <td style="border: 1px solid #000; font-weight: bold">
                          {{
                            getSums(
                              [
                                {
                                  indexs: ["riwayat_pekerjaan", "cabang_id"],
                                  val: cabang.id,
                                },
                                {
                                  indexs: ["riwayat_pekerjaan", "unit_id"],
                                  val: null,
                                },
                              ],
                              "gajisHonor",
                              "pot_bpjs_tk_dua_persen",
                            )
                          }}
                        </td>
                        <td style="border: 1px solid #000; font-weight: bold">
                          {{
                            getSums(
                              [
                                {
                                  indexs: ["riwayat_pekerjaan", "cabang_id"],
                                  val: cabang.id,
                                },
                                {
                                  indexs: ["riwayat_pekerjaan", "unit_id"],
                                  val: null,
                                },
                              ],
                              "gajisHonor",
                              "ifg_mandiri",
                            )
                          }}
                        </td>

                        <td style="border: 1px solid #000; font-weight: bold">
                          {{
                            getSums(
                              [
                                {
                                  indexs: ["riwayat_pekerjaan", "cabang_id"],
                                  val: cabang.id,
                                },
                                {
                                  indexs: ["riwayat_pekerjaan", "unit_id"],
                                  val: null,
                                },
                              ],
                              "gajisHonor",
                              "total_diterima",
                            )
                          }}
                        </td>

                        <td
                          style="border: 1px solid #000"
                          class="bottom-text"
                        ></td>
                        <td class="bottom-text"></td>
                      </tr>
                      <tr
                        v-if="cabangIndex === cabangs.length - 1"
                        class="top-text table-row-vfor"
                      >
                        <td
                          style="
                            border: 1px solid #000;
                            font-weight: bold;
                            text-align: center;
                          "
                          colspan="4"
                        >
                          TOTAL JUMLAH
                          <!-- JUMLAH I - -->
                          <!-- {{ commonFunction.convertToRoman(indexTableHonor) }} -->
                        </td>
                        <td style="border: 1px solid #000"></td>
                        <td style="border: 1px solid #000"></td>

                        <td style="border: 1px solid #000; font-weight: bold">
                          {{
                            formatNumber(gajisHonor.totalGajis.honor_umk_jml)
                          }}
                        </td>

                        <td style="border: 1px solid #000; font-weight: bold">
                          {{
                            formatNumber(
                              gajisHonor.totalGajis.kenaikan_masa_kerja,
                            )
                          }}
                        </td>

                        <td style="border: 1px solid #000; font-weight: bold">
                          {{
                            formatNumber(gajisHonor.totalGajis.tun_kesehatan)
                          }}
                        </td>
                        <td style="border: 1px solid #000; font-weight: bold">
                          {{
                            formatNumber(gajisHonor.totalGajis.premi_jkk) || 0
                          }}
                        </td>
                        <td style="border: 1px solid #000; font-weight: bold">
                          {{
                            formatNumber(gajisHonor.totalGajis.premi_jkm) || 0
                          }}
                        </td>

                        <td style="border: 1px solid #000; font-weight: bold">
                          {{
                            formatNumber(gajisHonor.totalGajis.jml_tdk_hadir)
                          }}
                        </td>

                        <td style="border: 1px solid #000; font-weight: bold">
                          {{ formatNumber(gajisHonor.totalGajis.pot_5_persen) }}
                        </td>

                        <td style="border: 1px solid #000; font-weight: bold">
                          {{ formatNumber(gajisHonor.totalGajis.jml_bruto) }}
                        </td>

                        <td style="border: 1px solid #000; font-weight: bold">
                          {{
                            formatNumber(gajisHonor.totalGajis.pot_kesehatan)
                          }}
                        </td>

                        <td style="border: 1px solid #000; font-weight: bold">
                          {{
                            formatNumber(
                              gajisHonor.totalGajis.pot_bpjs_tk_dua_persen,
                            )
                          }}
                        </td>
                        <td style="border: 1px solid #000; font-weight: bold">
                          {{
                            formatNumber(gajisHonor.totalGajis.ifg_mandiri) || 0
                          }}
                        </td>

                        <td style="border: 1px solid #000; font-weight: bold">
                          {{
                            formatNumber(gajisHonor.totalGajis.total_diterima)
                          }}
                        </td>

                        <td
                          style="border: 1px solid #000"
                          class="bottom-text"
                        ></td>
                        <td class="bottom-text"></td>
                      </tr>
                    </table>
                  </div>
                </div>
              </div>
            </div>
            <!-- /col-12  -->
          </div>
        </div>
        <!-- //shouldPrintGaji -->
      </div>
      <!-- end of v-for cabangs HONOR -->
      <div
        class="arial12"
        v-if="gajisHonor"
        style="margin-top: 0px; padding-top: 0px"
      >
        <div class="col-12">
          <p>
            Terbilang : -----
            {{ formatNumberTerbilang(gajisHonor.totalGajis.jml_bruto) }}
            Rupiah -----
          </p>
        </div>
        <div class="row" style="text-align: center">
          <div class="col-4">
            Perumda Air Minum <br />
            Tirta Hita Buleleng <br />
            Mengetahui: <br />
            <br />

            <div
              style="text-decoration: underline; padding-top: 35px"
              v-if="pejabat.dirum"
            >
              {{ pejabat.dirum.nama }}
            </div>

            Direktur Umum
          </div>
          <div class="col-4">
            <br />
            <br />

            Diperiksa:<br />
            <br />

            <!-- <div
              style="text-decoration: underline; padding-top: 35px"
              v-if="pejabatMengetahui"
            >
              {{ pejabatMengetahui.nama }}
            </div>
            Kepala Bagian Umum -->
            <div
              style="text-decoration: underline; padding-top: 35px"
              v-if="pejabat.pejabatMengetahui"
            >
              {{ pejabat.pejabatMengetahui.nama }}
            </div>
            <div v-if="pejabat.pejabatMengetahui">
              {{ pejabat.pejabatMengetahui.jabatan }}
            </div>
          </div>
          <div class="col-4">
            <br />

            Singaraja,
            {{ this.pejabatMembuatTgl }}
            <br />

            Dibuat Oleh:<br />
            <br />

            <div
              style="text-decoration: underline; padding-top: 35px"
              v-if="pejabat.pejabatMembuat"
            >
              {{ pejabat.pejabatMembuat.nama }}
            </div>
            <div v-if="pejabat.pejabatMembuat">
              {{ pejabat.pejabatMembuat.jabatan }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- /v-for cabangs END OF HONOR-->

    <!-- //////////////////////////////START OF KONTRAK ///////////////////////////////////////////// -->

    <div v-if="gajisKontrak">
      <div v-for="(cabang, cabangIndex) in cabangs" :key="cabang.id">
        <div
          v-if="
            shouldPrintGaji(
              [
                {
                  indexs: ['riwayat_pekerjaan', 'cabang_id'],
                  val: cabang.id,
                },
                {
                  indexs: ['riwayat_pekerjaan', 'unit_id'],
                  val: null,
                },
              ],
              'gajisKontrak',
            ) !== 'skip'
          "
        >
          <div class="row add-page-break-before">
            <div class="col-12">
              <div class="p-3 mb-3">
                <div class="row">
                  <div class="col-12">
                    <h4 class="header-title">
                      <strong
                        >GAJI/UPAH TENAGA KONTRAK KANTOR
                        {{ toUpper(cabang.nama) }}
                      </strong>
                    </h4>
                    <h5 class="header-periode" style="padding-bottom: 20px">
                      <strong
                        >UNTUK BULAN: {{ printBulanNama() }}
                        {{ printTahun() }}</strong
                      >
                    </h5>

                    <table class="table">
                      <thead>
                        <tr class="center-top-text">
                          <th rowspan="3">NO</th>
                          <th rowspan="3">NAMA</th>
                          <th rowspan="3">GOL.</th>
                          <th rowspan="3">JABATAN</th>
                          <th rowspan="3">MASA KERJA</th>
                          <th rowspan="3">TMT<br />KONTRAK</th>
                          <th rowspan="2">UPAH (UMK)</th>
                          <th rowspan="2">
                            TAMB. UPAH<br />MASA KERJA
                            <div class="small-text">(MK x 3% x UMK)</div>
                          </th>
                          <th rowspan="2">TUNJ. <br />KESEHATAN</th>
                          <th rowspan="2">TUNJ.<br />PREMI<br />JKK</th>
                          <th rowspan="2">TUNJ.<br />PREMI<br />JKM</th>
                          <th rowspan="3">JML <br />TIDAK<br />MASUK</th>
                          <th rowspan="2">
                            POT.<br />KETIDAKHADIRAN
                            <div class="small-text">(2%x7)10</div>
                          </th>
                          <th rowspan="2">JUMLAH</th>
                          <th rowspan="2">
                            TUNJ. BPJS<br />T.KERJA
                            <div class="small-text">(7+8)x1.19%</div>
                          </th>
                          <th rowspan="2">JUMLAH<br />BRUTO</th>

                          <th rowspan="1" colspan="3">POTONGAN</th>
                          <th rowspan="2">GAJI/UPAH <br />DITERIMA</th>
                          <th rowspan="3" colspan="2">TANDA<br />TANGAN</th>
                        </tr>

                        <tr class="center-top-text">
                          <th>KESEHATAN</th>
                          <th>
                            BPJS TK
                            <div class="small-text">(7+8)x1.19%</div>
                          </th>
                          <th>IFG LIFE<br />MANDIRI</th>
                        </tr>

                        <tr class="center-top-text">
                          <th style="border: none">(Rp.)</th>
                          <th>(Rp.)</th>
                          <th>(Rp.)</th>
                          <th>(Rp.)</th>
                          <th>(Rp.)</th>
                          <th>(Rp.)</th>
                          <th>(Rp.)</th>
                          <th>(Rp.)</th>
                          <th>(Rp.)</th>
                          <th>(Rp.)</th>
                          <th>(Rp.)</th>
                          <th>(Rp.)</th>
                          <th>(Rp.)</th>
                        </tr>
                        <tr class="center-top-text">
                          <th>1</th>
                          <th>2</th>
                          <th>3</th>
                          <th>4</th>
                          <th>5</th>
                          <th>6</th>
                          <th>7</th>
                          <th>8</th>
                          <th>9</th>
                          <th>10</th>
                          <th>11</th>
                          <th>12</th>
                          <th>13</th>
                          <th>14</th>
                          <th>15</th>
                          <th>16</th>
                          <th>17</th>
                          <th>18</th>
                          <th>19</th>
                          <th>20</th>
                          <th></th>
                          <th>21</th>
                        </tr>
                      </thead>

                      <tbody>
                        <tr
                          v-for="(item, index) in filterGajisByConditions(
                            [
                              {
                                indexs: ['riwayat_pekerjaan', 'cabang_id'],
                                val: cabang.id,
                              },
                              // {
                              //   indexs: ['riwayat_pekerjaan', 'unit_id'],
                              //   val: null,
                              // },
                            ],
                            '',
                            'gajisKontrak',
                          )"
                          :key="item.id"
                          :class="getPageBreakStyleHonorKontrak(index)"
                        >
                          <!-- :class="'top-text table-row-vfor'"
                            :style="getPageBreakStyle(index)" -->
                          <td
                            style="border: 1px solid #000; text-align: center"
                            :ref="'refTdKontrak-' + cabangIndex + '-' + index"
                          >
                            k
                            {{ printRefTdKontrak(cabangIndex, index) }}
                            <!-- {{ cabangIndex }} -->
                          </td>
                          <td style="border: 1px solid #000">
                            <!-- {{ item.pegawai.nama }} -->
                            {{ item.pegawai.nama }}
                          </td>
                          <td
                            style="border: 1px solid #000; text-align: center"
                          >
                            <!-- {{ item.golongan.nama }} PERBAIKI GAJI YAA KARENA JUNI TIDAK ADA GOLONGAN_ID-->
                            {{ printGolKontrak(item.golongan.nama) }}
                          </td>

                          <td style="border: 1px solid #000">
                            <div v-if="shouldRenderSubBagian">
                              {{
                                printJabatanHonorKontrak(item.riwayat_pekerjaan)
                              }}
                            </div>
                          </td>

                          <td style="border: 1px solid #000">
                            <!-- {{ printMasaKerjaHonorKontrak(item) }} -->
                            {{ item.masa_kerja }} tahun
                          </td>

                          <td style="border: 1px solid #000">
                            {{
                              convertTglFormat(item.pegawai.tgl_mulai_bekerja)
                            }}
                          </td>

                          <td style="border: 1px solid #000">
                            {{ formatNumber(item.honor_umk_jml) }}
                          </td>

                          <td style="border: 1px solid #000">
                            {{ formatNumber(item.kenaikan_masa_kerja) }}
                          </td>

                          <td style="border: 1px solid #000">
                            {{ formatNumber(item.tun_kesehatan) }}
                          </td>
                          <td style="border: 1px solid #000">
                            {{ formatNumber(item.premi_jkk) }}
                          </td>
                          <td style="border: 1px solid #000">
                            {{ formatNumber(item.premi_jkm) }}
                          </td>

                          <td style="border: 1px solid #000">
                            {{ formatNumber(item.jml_tdk_hadir) }}
                          </td>

                          <td style="border: 1px solid #000">
                            {{ formatNumber(item.pot_5_persen) }}
                          </td>

                          <td style="border: 1px solid #000">
                            {{
                              formatNumber(
                                item.honor_umk_jml +
                                  item.kenaikan_masa_kerja +
                                  item.premi_jkk +
                                  item.premi_jkm +
                                  item.tun_kesehatan -
                                  item.pot_5_persen,
                              )
                            }}
                          </td>
                          <td style="border: 1px solid #000">
                            {{
                              formatNumber(
                                item.tun_bpjs_tk_satu_sembilanbelas_persen,
                              )
                            }}
                          </td>

                          <td style="border: 1px solid #000">
                            {{ formatNumber(item.jml_bruto) }}
                          </td>

                          <td style="border: 1px solid #000">
                            {{ formatNumber(item.pot_kesehatan) }}
                          </td>

                          <td style="border: 1px solid #000">
                            {{
                              formatNumber(
                                item.pot_bpjs_tk_satu_sembilanbelas_persen,
                              )
                            }}
                          </td>
                          <td style="border: 1px solid #000">
                            {{ formatNumber(item.ifg_mandiri) }}
                          </td>

                          <td style="border: 1px solid #000">
                            {{ formatNumber(item.total_diterima) }}
                          </td>

                          <td
                            style="border: 1px solid #000"
                            class="bottom-text"
                            :ref="
                              'refTdKontrakTTD-' + cabangIndex + '-' + index
                            "
                          >
                            {{ printRefTdKontrakTTD(cabangIndex, index) }}
                          </td>
                          <td class="bottom-text">...............</td>
                        </tr>
                      </tbody>
                      <tr
                        class="top-text table-row-vfor"
                        v-if="gajisKontrak.totalGajis"
                      >
                        <td
                          style="
                            border: 1px solid #000;
                            font-weight: bold;
                            text-align: center;
                          "
                          colspan="4"
                        >
                          JUMLAH
                          <!-- <span
                            v-for="index in cabangs.length"
                            :key="index"
                            style="margin-right: 1px"
                          >
                            {{ index }}
                          </span> -->
                          <!-- {{ commonFunction.convertToRoman(cabangIndex + 1) }} -->
                        </td>
                        <td style="border: 1px solid #000"></td>
                        <td style="border: 1px solid #000"></td>

                        <td style="border: 1px solid #000; font-weight: bold">
                          {{
                            getSums(
                              [
                                {
                                  indexs: ["riwayat_pekerjaan", "cabang_id"],
                                  val: cabang.id,
                                },
                                // {
                                //   indexs: ["riwayat_pekerjaan", "unit_id"],
                                //   val: null,
                                // },
                              ],
                              "gajisKontrak",
                              "honor_umk_jml",
                            )
                          }}
                        </td>

                        <td style="border: 1px solid #000; font-weight: bold">
                          {{
                            getSums(
                              [
                                {
                                  indexs: ["riwayat_pekerjaan", "cabang_id"],
                                  val: cabang.id,
                                },
                                {
                                  indexs: ["riwayat_pekerjaan", "unit_id"],
                                  val: null,
                                },
                              ],
                              "gajisKontrak",
                              "kenaikan_masa_kerja",
                            )
                          }}
                        </td>

                        <td style="border: 1px solid #000; font-weight: bold">
                          {{
                            getSums(
                              [
                                {
                                  indexs: ["riwayat_pekerjaan", "cabang_id"],
                                  val: cabang.id,
                                },
                                {
                                  indexs: ["riwayat_pekerjaan", "unit_id"],
                                  val: null,
                                },
                              ],
                              "gajisKontrak",
                              "tun_kesehatan",
                            )
                          }}
                        </td>
                        <td style="border: 1px solid #000; font-weight: bold">
                          {{
                            getSums(
                              [
                                {
                                  indexs: ["riwayat_pekerjaan", "cabang_id"],
                                  val: cabang.id,
                                },
                                {
                                  indexs: ["riwayat_pekerjaan", "unit_id"],
                                  val: null,
                                },
                              ],
                              "gajisKontrak",
                              "premi_jkk",
                            )
                          }}
                        </td>
                        <td style="border: 1px solid #000; font-weight: bold">
                          {{
                            getSums(
                              [
                                {
                                  indexs: ["riwayat_pekerjaan", "cabang_id"],
                                  val: cabang.id,
                                },
                                {
                                  indexs: ["riwayat_pekerjaan", "unit_id"],
                                  val: null,
                                },
                              ],
                              "gajisKontrak",
                              "premi_jkm",
                            )
                          }}
                        </td>

                        <td style="border: 1px solid #000; font-weight: bold">
                          {{
                            getSums(
                              [
                                {
                                  indexs: ["riwayat_pekerjaan", "cabang_id"],
                                  val: cabang.id,
                                },
                                {
                                  indexs: ["riwayat_pekerjaan", "unit_id"],
                                  val: null,
                                },
                              ],
                              "gajisKontrak",
                              "jml_tdk_hadir",
                            )
                          }}
                        </td>

                        <td style="border: 1px solid #000; font-weight: bold">
                          {{
                            getSums(
                              [
                                {
                                  indexs: ["riwayat_pekerjaan", "cabang_id"],
                                  val: cabang.id,
                                },
                                {
                                  indexs: ["riwayat_pekerjaan", "unit_id"],
                                  val: null,
                                },
                              ],
                              "gajisKontrak",
                              "pot_5_persen",
                            )
                          }}
                        </td>
                        <td style="border: 1px solid #000; font-weight: bold">
                          {{
                            getSumsColJml(
                              [
                                {
                                  indexs: ["riwayat_pekerjaan", "cabang_id"],
                                  val: cabang.id,
                                },
                                {
                                  indexs: ["riwayat_pekerjaan", "unit_id"],
                                  val: null,
                                },
                              ],
                              "gajisKontrak",
                              true,
                            )
                          }}
                        </td>

                        <td style="border: 1px solid #000; font-weight: bold">
                          {{
                            getSums(
                              [
                                {
                                  indexs: ["riwayat_pekerjaan", "cabang_id"],
                                  val: cabang.id,
                                },
                                {
                                  indexs: ["riwayat_pekerjaan", "unit_id"],
                                  val: null,
                                },
                              ],
                              "gajisKontrak",
                              "tun_bpjs_tk_satu_sembilanbelas_persen",
                            )
                          }}
                        </td>

                        <td style="border: 1px solid #000; font-weight: bold">
                          {{
                            getSums(
                              [
                                {
                                  indexs: ["riwayat_pekerjaan", "cabang_id"],
                                  val: cabang.id,
                                },
                                {
                                  indexs: ["riwayat_pekerjaan", "unit_id"],
                                  val: null,
                                },
                              ],
                              "gajisKontrak",
                              "jml_bruto",
                            )
                          }}
                        </td>

                        <td style="border: 1px solid #000; font-weight: bold">
                          {{
                            getSums(
                              [
                                {
                                  indexs: ["riwayat_pekerjaan", "cabang_id"],
                                  val: cabang.id,
                                },
                                {
                                  indexs: ["riwayat_pekerjaan", "unit_id"],
                                  val: null,
                                },
                              ],
                              "gajisKontrak",
                              "pot_kesehatan",
                            )
                          }}
                        </td>

                        <td style="border: 1px solid #000; font-weight: bold">
                          {{
                            getSums(
                              [
                                {
                                  indexs: ["riwayat_pekerjaan", "cabang_id"],
                                  val: cabang.id,
                                },
                                {
                                  indexs: ["riwayat_pekerjaan", "unit_id"],
                                  val: null,
                                },
                              ],
                              "gajisKontrak",
                              "pot_bpjs_tk_satu_sembilanbelas_persen",
                            )
                          }}
                        </td>
                        <td style="border: 1px solid #000; font-weight: bold">
                          {{
                            getSums(
                              [
                                {
                                  indexs: ["riwayat_pekerjaan", "cabang_id"],
                                  val: cabang.id,
                                },
                                {
                                  indexs: ["riwayat_pekerjaan", "unit_id"],
                                  val: null,
                                },
                              ],
                              "gajisKontrak",
                              "ifg_mandiri",
                            )
                          }}
                        </td>

                        <td style="border: 1px solid #000; font-weight: bold">
                          {{
                            getSums(
                              [
                                {
                                  indexs: ["riwayat_pekerjaan", "cabang_id"],
                                  val: cabang.id,
                                },
                                {
                                  indexs: ["riwayat_pekerjaan", "unit_id"],
                                  val: null,
                                },
                              ],
                              "gajisKontrak",
                              "total_diterima",
                            )
                          }}
                        </td>

                        <td
                          style="border: 1px solid #000"
                          class="bottom-text"
                        ></td>
                        <td class="bottom-text"></td>
                      </tr>
                      <tr
                        v-if="cabangIndex === cabangs.length - 1"
                        class="top-text table-row-vfor"
                      >
                        <td
                          style="
                            border: 1px solid #000;
                            font-weight: bold;
                            text-align: center;
                          "
                          colspan="4"
                        >
                          TOTAL JUMLAH
                          <!-- I s.d -->
                          <!-- {{ commonFunction.convertToRoman(cabangs.length) }} -->
                        </td>
                        <td style="border: 1px solid #000"></td>
                        <td style="border: 1px solid #000"></td>

                        <td style="border: 1px solid #000; font-weight: bold">
                          {{
                            formatNumber(gajisKontrak.totalGajis.honor_umk_jml)
                          }}
                        </td>

                        <td style="border: 1px solid #000; font-weight: bold">
                          {{
                            formatNumber(
                              gajisKontrak.totalGajis.kenaikan_masa_kerja,
                            )
                          }}
                        </td>

                        <td style="border: 1px solid #000; font-weight: bold">
                          {{
                            formatNumber(gajisKontrak.totalGajis.tun_kesehatan)
                          }}
                        </td>

                        <td style="border: 1px solid #000; font-weight: bold">
                          {{
                            formatNumber(gajisKontrak.totalGajis.premi_jkk) || 0
                          }}
                        </td>
                        <td style="border: 1px solid #000; font-weight: bold">
                          {{
                            formatNumber(gajisKontrak.totalGajis.premi_jkm) || 0
                          }}
                        </td>

                        <td style="border: 1px solid #000; font-weight: bold">
                          {{
                            formatNumber(gajisKontrak.totalGajis.jml_tdk_hadir)
                          }}
                        </td>

                        <td style="border: 1px solid #000; font-weight: bold">
                          {{
                            formatNumber(gajisKontrak.totalGajis.pot_5_persen)
                          }}
                        </td>

                        <td style="border: 1px solid #000; font-weight: bold">
                          {{ getSumsColJml([], "gajisKontrak", true) }}
                        </td>

                        <td style="border: 1px solid #000; font-weight: bold">
                          {{
                            formatNumber(
                              gajisKontrak.totalGajis
                                .tun_bpjs_tk_satu_sembilanbelas_persen,
                            )
                          }}
                        </td>
                        <td style="border: 1px solid #000; font-weight: bold">
                          {{ formatNumber(gajisKontrak.totalGajis.jml_bruto) }}
                        </td>

                        <td style="border: 1px solid #000; font-weight: bold">
                          {{
                            formatNumber(gajisKontrak.totalGajis.pot_kesehatan)
                          }}
                        </td>

                        <td style="border: 1px solid #000; font-weight: bold">
                          {{
                            formatNumber(
                              gajisKontrak.totalGajis
                                .pot_bpjs_tk_satu_sembilanbelas_persen,
                            )
                          }}
                        </td>
                        <td style="border: 1px solid #000; font-weight: bold">
                          {{
                            formatNumber(gajisKontrak.totalGajis.ifg_mandiri) ||
                            0
                          }}
                        </td>

                        <td style="border: 1px solid #000; font-weight: bold">
                          {{
                            formatNumber(gajisKontrak.totalGajis.total_diterima)
                          }}
                        </td>

                        <td
                          style="border: 1px solid #000"
                          class="bottom-text"
                        ></td>
                        <td class="bottom-text"></td>
                      </tr>
                    </table>
                  </div>
                </div>
              </div>
            </div>
            <!-- /col-12  -->
          </div>
        </div>
        <!-- //shouldPrintGaji -->
      </div>
      <!-- end of v-for cabangs KONTRAK -->
      <div class="row arial12" v-if="gajisKontrak">
        <div class="col-12">
          <p>
            Terbilang : -----
            {{ formatNumberTerbilang(gajisKontrak.totalGajis.jml_bruto) }}
            Rupiah -----
          </p>
        </div>
        <div class="row" style="text-align: center">
          <div class="col-4">
            Perumda Air Minum <br />
            Tirta Hita Buleleng <br />
            Mengetahui: <br />
            <br />

            <div
              style="text-decoration: underline; padding-top: 35px"
              v-if="pejabat.dirum"
            >
              {{ pejabat.dirum.nama }}
            </div>

            Direktur Umum
          </div>
          <div class="col-4">
            <br />
            <br />

            Diperiksa:<br />
            <br />

            <!-- <div
              style="text-decoration: underline; padding-top: 35px"
              v-if="pejabatMengetahui"
            >
              {{ pejabatMengetahui.nama }}
            </div>
            Kepala Bagian Umum -->
            <div
              style="text-decoration: underline; padding-top: 35px"
              v-if="pejabat.pejabatMengetahui"
            >
              {{ pejabat.pejabatMengetahui.nama }}
            </div>
            <div v-if="pejabat.pejabatMengetahui">
              {{ pejabat.pejabatMengetahui.jabatan }}
            </div>
          </div>
          <div class="col-4">
            <br />

            Singaraja,
            {{ this.pejabatMembuatTgl }}
            <br />

            Dibuat Oleh:<br />
            <br />

            <div
              style="text-decoration: underline; padding-top: 35px"
              v-if="pejabat.pejabatMembuat"
            >
              {{ pejabat.pejabatMembuat.nama }}
            </div>
            <div v-if="pejabat.pejabatMembuat">
              {{ pejabat.pejabatMembuat.jabatan }}
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- /////////////////////////////////START OF DEWAS//////////////////////////////////////////// -->
    <div class="row add-page-break-before">
      <div class="col-12">
        <div class="p-3 mb-3">
          <div class="row">
            <div class="col-12">
              <h5
                style="
                  font-weight: bold;
                  font-family: Arial, sans-serif;
                  font-size: 12px;
                "
              >
                PERUSAHAAN UMUM DAERAH AIR MINUM
              </h5>
              <h5
                style="
                  font-weight: bold;
                  font-family: Arial, sans-serif;
                  font-size: 12px;
                "
              >
                TIRTA HITA BULELENG
              </h5>
              <h4 class="header-title table-dewas">
                <strong>UANG JASA DEWAN PENGAWAS</strong>
              </h4>
              <h5 class="header-title table-dewas">
                <strong
                  >UNTUK BULAN: {{ printBulanNama() }}
                  {{ printTahun() }}</strong
                >
              </h5>
              <h5 class="header-title table-dewas">
                <strong
                  >SESUAI KUASA PEMILIK MODAL PERUMDA AIR MINUM TIRTA HITA
                  BULELENG</strong
                >
              </h5>
              <h5 class="header-title table-dewas">
                <strong
                  >NOMOR 03 / Skep / KPM / THB / VIII / 2024 Tanggal 7 Agustus
                  2024</strong
                >
              </h5>

              <table class="table table-dewas" v-if="gajisDewas" width="80%">
                <thead>
                  <tr class="center-top-text">
                    <th rowspan="2">NO</th>
                    <th rowspan="2" style="min-width: 120px">NAMA</th>
                    <th rowspan="2">JABATAN</th>
                    <th>BESARNYA<br />UANG JASA</th>
                    <th>POT. PPH <br />PASAL 21</th>
                    <th>JML YG<br />DITERIMA</th>
                    <th rowspan="2" style="width: 2%" class="no-right-border">
                      &nbsp;
                    </th>
                    <th rowspan="2">TANDA TANGAN</th>
                  </tr>

                  <tr class="center-top-text">
                    <th style="border: none">(Rp.)</th>
                    <th>(Rp.)</th>
                    <th>(Rp.)</th>
                  </tr>
                  <tr class="center-top-text">
                    <th>1</th>
                    <th>2</th>
                    <th>3</th>
                    <th>4</th>
                    <th>5</th>
                    <th>6</th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="(item, index) in gajisDewas.gajis"
                    :key="item.id"
                    :class="getPageBreakStyle(index)"
                  >
                    <td style="border: 1px solid #000; text-align: center">
                      {{ index + 1 }}
                    </td>
                    <td style="border: 1px solid #000; min-width: 120px">
                      {{ item.dewas.nama }}
                    </td>
                    <td style="border: 1px solid #000">
                      {{ item.dewas_riwayat_pekerjaan.jabatan.nama }}
                    </td>

                    <td style="border: 1px solid #000">
                      {{ formatNumber(item.uang_jasa) }}
                    </td>

                    <td style="border: 1px solid #000">
                      {{ formatNumber(item.pot_pph) }}
                    </td>

                    <td style="border: 1px solid #000">
                      {{ formatNumber(item.total_diterima) }}
                    </td>

                    <td style="border: 1px solid #000" class="bottom-text">
                      {{ index + 1 }}
                    </td>
                    <td class="bottom-text">...............</td>
                  </tr>
                </tbody>
                <tr class="top-text table-row-vfor" v-if="gajisDewas">
                  <td style="border: 1px solid #000; font-weight: bold"></td>
                  <td style="border: 1px solid #000; font-weight: bold">
                    JUMLAH
                  </td>
                  <td style="border: 1px solid #000; font-weight: bold"></td>

                  <td style="border: 1px solid #000; font-weight: bold">
                    {{ formatNumber(gajisDewas.totalGajis.uang_jasa) }}
                  </td>

                  <td style="border: 1px solid #000; font-weight: bold">
                    {{ formatNumber(gajisDewas.totalGajis.pot_pph) }}
                  </td>

                  <td style="border: 1px solid #000; font-weight: bold">
                    {{ formatNumber(gajisDewas.totalGajis.total_diterima) }}
                  </td>

                  <td
                    style="border: 1px solid #000; font-weight: bold"
                    class="bottom-text"
                  ></td>
                  <td class="bottom-text"></td>
                </tr>
                <!-- <tr></tr> -->
              </table>
              <div class="row arial12" v-if="gajisDewas">
                <div class="col-12">
                  <p>
                    Terbilang : -----
                    {{
                      formatNumberTerbilang(
                        gajisDewas.totalGajis.total_diterima,
                      )
                    }}
                    Rupiah -----
                  </p>
                </div>
                <div class="row table-dewas" style="text-align: center">
                  <div class="col-4">
                    <br />
                    <br />

                    Mengetahui:<br />
                    <br />
                    <div
                      style="text-decoration: underline; padding-top: 50px"
                      v-if="pejabat.dirum"
                    >
                      {{ pejabat.dirum.nama }}
                    </div>

                    Direktur Umum
                  </div>
                  <div class="col-4">
                    <br />
                    <br />

                    Diperiksa:<br />
                    <br />

                    <!-- <div
                      style="text-decoration: underline; padding-top: 35px"
                      v-if="pejabatMengetahui"
                    >
                      {{ pejabatMengetahui.nama }}
                    </div>
                    Kepala Bagian Umum -->
                    <div
                      style="text-decoration: underline; padding-top: 35px"
                      v-if="pejabat.pejabatMengetahui"
                    >
                      {{ pejabat.pejabatMengetahui.nama }}
                    </div>
                    <div v-if="pejabat.pejabatMengetahui">
                      {{ pejabat.pejabatMengetahui.jabatan }}
                    </div>
                  </div>
                  <div class="col-4">
                    <br />

                    Singaraja,
                    {{ this.pejabatMembuatTgl }}
                    <br />

                    Dibuat Oleh:<br />
                    <br />

                    <div
                      style="text-decoration: underline; padding-top: 35px"
                      v-if="pejabat.pejabatMembuat"
                    >
                      {{ pejabat.pejabatMembuat.nama }}
                    </div>
                    <div v-if="pejabat.pejabatMembuat">
                      {{ pejabat.pejabatMembuat.jabatan }}
                    </div>
                  </div>
                </div>
                <div
                  class="row table-dewas"
                  style="text-align: center; padding-top: 35px"
                >
                  <div class="col-4"></div>
                  <div class="col-4">
                    PERUSAHAAN UMUM AIR MINUM <br />
                    TIRTA HITA BULELENG <br />
                    Menyetujui:<br />
                    <br />
                    <div
                      style="text-decoration: underline; padding-top: 35px"
                      v-if="pejabatDirut"
                    >
                      {{ pejabatDirut.nama }}
                    </div>
                    Direktur Utama
                  </div>
                  <div class="col-4"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- /col-12 -->
    </div>
    <!-- /row add-page-break-after  END OF GAJI DEWAS-->

    <!-- /////////////////////////////////START OF DEWASSEKRE//////////////////////////////////////////// -->
    <div class="row add-page-break-before">
      <div class="col-12">
        <div class="p-3 mb-3">
          <div class="row">
            <div class="col-12">
              <h5
                style="
                  font-weight: bold;
                  font-family: Arial, sans-serif;
                  font-size: 12px;
                "
              >
                PERUSAHAAN UMUM DAERAH AIR MINUM
              </h5>
              <h5
                style="
                  font-weight: bold;
                  font-family: Arial, sans-serif;
                  font-size: 12px;
                "
              >
                TIRTA HITA BULELENG
              </h5>
              <h4 class="header-title table-dewas">
                <strong>HONORARIUM SEKRETARIAT DEWAN PENGAWAS </strong>
              </h4>
              <h5 class="header-title table-dewas">
                <strong
                  >UNTUK BULAN: {{ printBulanNama() }}
                  {{ printTahun() }}</strong
                >
              </h5>
              <h5 class="header-title table-dewas">
                <strong
                  >SESUAI KEPUTUSAN DIREKSI PERUMDA AIR MINUM TIRTA HITA
                  BULELENG
                </strong>
              </h5>
              <h5 class="header-title table-dewas">
                <strong>NOMOR 231 TAHUN 2022 TANGGAL 15 SEPTEMBER 2022 </strong>
              </h5>

              <table class="table table-dewas" v-if="gajisDewasSekre">
                <thead>
                  <tr class="center-top-text">
                    <th rowspan="2">NO</th>
                    <th rowspan="2" style="min-width: 120px">NAMA</th>
                    <th rowspan="2">JABATAN</th>
                    <th>BESARNYA<br />BESARNYA<br />HONOR</th>
                    <th>POT. PPH <br />PASAL 21</th>
                    <th>JML YG<br />DITERIMA</th>
                    <th rowspan="2" style="width: 2%" class="no-right-border">
                      &nbsp;
                    </th>
                    <th rowspan="2">TANDA TANGAN</th>
                  </tr>

                  <tr class="center-top-text">
                    <th style="border: none">(Rp.)</th>
                    <th>(Rp.)</th>
                    <th>(Rp.)</th>
                  </tr>
                  <tr class="center-top-text">
                    <th>1</th>
                    <th>2</th>
                    <th>3</th>
                    <th>4</th>
                    <th>5</th>
                    <th>6</th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="(item, index) in gajisDewasSekre.gajis"
                    :key="item.id"
                    :class="getPageBreakStyle(index)"
                  >
                    <td style="border: 1px solid #000; text-align: center">
                      {{ index + 1 }}
                    </td>
                    <td style="border: 1px solid #000; min-width: 120px">
                      {{ item.dewas.nama }}
                    </td>
                    <td style="border: 1px solid #000">
                      {{ item.dewas_riwayat_pekerjaan.jabatan.nama }}
                    </td>

                    <td style="border: 1px solid #000">
                      {{ formatNumber(item.honor) }}
                    </td>

                    <td style="border: 1px solid #000">
                      {{ formatNumber(item.pot_pph) }}
                    </td>

                    <td style="border: 1px solid #000">
                      {{ formatNumber(item.total_diterima) }}
                    </td>

                    <td style="border: 1px solid #000" class="bottom-text">
                      {{ index + 1 }}
                    </td>
                    <td class="bottom-text">...............</td>
                  </tr>
                </tbody>
                <tr class="top-text table-row-vfor" v-if="gajisDewasSekre">
                  <td style="border: 1px solid #000; font-weight: bold"></td>
                  <td style="border: 1px solid #000; font-weight: bold">
                    JUMLAH
                  </td>
                  <td style="border: 1px solid #000; font-weight: bold"></td>

                  <td style="border: 1px solid #000; font-weight: bold">
                    {{ formatNumber(gajisDewasSekre.totalGajis.honor) }}
                  </td>

                  <td style="border: 1px solid #000; font-weight: bold">
                    {{ formatNumber(gajisDewasSekre.totalGajis.pot_pph) }}
                  </td>

                  <td style="border: 1px solid #000; font-weight: bold">
                    {{
                      formatNumber(gajisDewasSekre.totalGajis.total_diterima)
                    }}
                  </td>

                  <td
                    style="border: 1px solid #000; font-weight: bold"
                    class="bottom-text"
                  ></td>
                  <td class="bottom-text"></td>
                </tr>
                <!-- <tr></tr> -->
              </table>
              <div class="row arial12 table-dewas" v-if="gajisDewasSekre">
                <div class="col-12">
                  <p>
                    Terbilang : -----
                    {{
                      formatNumberTerbilang(
                        gajisDewasSekre.totalGajis.total_diterima,
                      )
                    }}
                    Rupiah -----
                  </p>
                </div>
                <div class="row" style="text-align: center">
                  <div class="col-4">
                    <br />
                    <br />

                    Mengetahui:<br />
                    <br />
                    <div
                      style="text-decoration: underline; padding-top: 50px"
                      v-if="pejabat.dirum"
                    >
                      {{ pejabat.dirum.nama }}
                    </div>

                    Direktur Umum
                  </div>
                  <div class="col-4">
                    <br />
                    <br />

                    Diperiksa:<br />
                    <br />

                    <!-- <div
                      style="text-decoration: underline; padding-top: 35px"
                      v-if="pejabatMengetahui"
                    >
                      {{ pejabatMengetahui.nama }}
                    </div>
                    Kepala Bagian Umum -->
                    <div
                      style="text-decoration: underline; padding-top: 35px"
                      v-if="pejabat.pejabatMengetahui"
                    >
                      {{ pejabat.pejabatMengetahui.nama }}
                    </div>
                    <div v-if="pejabat.pejabatMengetahui">
                      {{ pejabat.pejabatMengetahui.jabatan }}
                    </div>
                  </div>
                  <div class="col-4">
                    <br />

                    Singaraja,
                    {{ this.pejabatMembuatTgl }}
                    <br />

                    Dibuat Oleh:<br />
                    <br />

                    <div
                      style="text-decoration: underline; padding-top: 35px"
                      v-if="pejabat.pejabatMembuat"
                    >
                      {{ pejabat.pejabatMembuat.nama }}
                    </div>
                    <div v-if="pejabat.pejabatMembuat">
                      {{ pejabat.pejabatMembuat.jabatan }}
                    </div>
                  </div>
                </div>
                <div class="row" style="text-align: center; padding-top: 35px">
                  <div class="col-4"></div>
                  <div class="col-4">
                    PERUSAHAAN UMUM AIR MINUM <br />
                    TIRTA HITA BULELENG <br />
                    Menyetujui:<br />
                    <br />
                    <div
                      style="text-decoration: underline; padding-top: 35px"
                      v-if="pejabat.dirut"
                    >
                      {{ pejabat.dirut.nama }}
                    </div>
                    Direktur Utama
                  </div>
                  <div class="col-4"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- /col-12 -->
    </div>
    <!-- /row add-page-break-after  END OF GAJI DEWASSEKRE-->

    <!-- /v-for cabangs END OF KONTRAK-->
  </div>
  <!-- /section-to-print -->
</template>

<style scoped lang="scss">
// FIX!

/* Style for the content on the screen */
// #section-to-print {
//   width: 100%;
//   height: auto;
//   background-color: white;
//   padding: 20px;
// }

// /* Define A3 size and landscape orientation when printing */
// @media print {
//   @page {
//     size: A3 landscape; /* Set the page size to A3 and orientation to landscape */
//     margin: 10mm; /* Adjust the margin as needed */
//   }

//   #section-to-print {
//     width: 100%;
//     height: auto;
//     /* Any additional styles specific to printing */
//   }
// }

.no-right-border {
  border-right: none !important;
}
.table-row-vfor {
  border: 1px solid #000;
  // border-left: 1px solid #000;
}

.center-top-text {
  vertical-align: top; /* Align text to the top */
  text-align: center; /* Center text horizontally */
}

.top-text {
  vertical-align: top;
}
.bottom-text {
  vertical-align: bottom;
}

.center-text {
  text-align: center;
}

.small-text {
  font-size: 8px;
}
.header-title {
  text-align: center;
  font-family: Arial, sans-serif; /* Set font to Arial */
  font-size: 12px;
}
.header-periode {
  text-align: center;
  font-family: Arial, sans-serif; /* Set font to Arial */
  font-size: 12px;
}

.add-page-break-before {
  page-break-before: always;
}
.add-page-break-after {
  page-break-after: always;
}

// /FIX!

.arial12 {
  font-family: Arial, sans-serif; /* Set font to Arial */
  font-size: 12px; /* Set font size to 10 */
}

/* .padded-column {
  padding-right: 100px;
} */
.table td:not(.padded-column) {
  border: none;
  padding-right: 15px;
  padding-top: 15px;
  padding-left: 15px;
  padding-bottom: 15px;
}

.padded-column {
  border: none;
  padding-right: 100px;
  padding-top: 15px;
  padding-left: 15px;
  padding-bottom: 15px;
}

.table th {
  background-color: #f0f0f0;
  font-weight: bold;
}

.table {
  width: 100%;
  border: 1px solid #000; /* Adjust the border thickness as needed */
  border: collapse;
  font-family: Arial, sans-serif; /* Set font to Arial */
  font-size: 10px; /* Set font size to 10 */
}

.table th,
.table td {
  vertical-align: top; /* Align text to the top */
  min-width: 5px; /* Ensure a minimum width for readability */
  max-width: 500px; /* Ensure a maximum width for readability */
  border: 1px solid #000; /* Adjust the border thickness as needed */
  padding: 1px; /* Adjust this value as needed */
  vertical-align: middle; /* Center align the text vertically */
}

.table-dewas {
  // margin: 0 auto !important; biar center to page
  width: 80% !important;
}

.table-fixed {
  table-layout: fixed; /* Ensures that column widths are respected */
}

.flexible-table {
  width: 100%; /* Let the table take the full width of the container */
}

.flexible-table th,
.flexible-table td {
  vertical-align: top; /* Align text to the top */
  min-width: 5px; /* Ensure a minimum width for readability */
  max-width: 200px; /* Ensure a maximum width for readability */
  white-space: nowrap; /* Prevent wrapping */
}

.flexible-table th,
.flexible-table td {
  overflow: hidden; /* Let the table cell grow based on its content */
}

.table-custom td,
.table-custom th {
  padding: 1px; /* Adjust this value as needed */
  vertical-align: middle; /* Center align the text vertically */
}

.col-pegawai {
  width: 20%;
}

td {
  page-break-inside: avoid !important;
}

.no-border-terbilang {
  border-top: 1px solid #000 !important;
  border-style: hidden !important;
}

.no-margin-br br {
  margin: 0;
  padding: 0;
  line-height: 0.8; /* Adjust as needed */
}

@media print {
  // table {
  //   page-break-inside: avoid;
  // } lama

  table {
    page-break-inside: auto;
  }

  tr {
    break-inside: avoid;
  }
  // tbody {
  //   display: block;
  // }
}
</style>
<script>
// import { useGajiListStore } from "@/stores/views/gaji-list-store";
import axios from "axios";
import api from "@/api";
import { API_BASE_URL } from "@/global-constants";
import angkaTerbilang from "@develoka/angka-terbilang-js";
import _ from "lodash";
import { DateTime } from "luxon";
import { useCommonStore } from "@/stores/utility/common-store2";
import * as commonFunction from "@/utils/common-function.js";

let indexTableHonor = 1;
export default {
  // Component logic goes here
  setup() {
    const commonStore = useCommonStore();
    // const gajiListStore = useGajiListStore();
    return {
      commonStore,
      // gajiListStore,
      commonFunction,
    };
  },
  data() {
    return {
      tglGaji: this.$route.query.tgl,

      listGajisTetap: null,
      gajis: null,
      gajisHonor: null,
      gajisHonorLength: null,
      gajisKontrak: null,
      gajisDireksi: null,
      gajisDewas: null,
      gajisDewasSekre: null,

      pejabatMengetahui: null,
      pejabatMembuat: null,
      pejabatMembuatTgl: "",
      pejabatMenyetujui: null,
      pejabatDirut: null,
      pejabat: null,
      cabangs: null,
      units: null,
      cabangsLength: null,
      bagians: null,
      bidangs: null,
      subBagians: null,
      subBidangs: null,
      seksis: null,
      jabatans: null,
      totalRows: 0,
      previousSubBagianId: null,
      indexHonor: 0,
      indexKontrak: 0,
      indexTableKontrak: 1,
      gajiIndexLength: 0,
      printResults: [], // Array to store the results
    };
  },
  async created() {
    await this.commonStore.preloadStores();
  },
  async mounted() {
    this.pejabat = await this.commonFunction.getPejabatPengesahan(
      // DateTime.now().startOf("month").toISODate(),
      this.tglGaji,
    );

    this.cabangs = _.sortBy(this.commonStore.cabangStore, ["id"]);

    this.bagians = _.sortBy(
      _.filter(this.commonStore.bagianStore, (item) => item.id !== null),
      ["id"],
    );

    // this.bidangs = _.sortBy(this.commonStore.bidangStore, ["id"]);
    this.bidangs = _.sortBy(
      _.filter(this.commonStore.bidangStore, (item) => item.id !== null),
      ["id"],
    );

    this.units = _.sortBy(
      _.filter(this.commonStore.unitStore, (item) => item.id !== null),
      ["id"],
    );

    this.subBagians = _.sortBy(this.commonStore.subBagianStore, ["order"]);
    this.cabangsLength = this.cabangs.length;

    this.subBidangs = _.sortBy(this.commonStore.subBidangStore, ["order"]);
    this.seksis = _.sortBy(this.commonStore.seksiStore, ["order"]);
    this.jabatans = _.sortBy(this.commonStore.jabatanStore, ["id"]);
    await this.fetchDataPejabatPembuatGaji();

    this.gajisDewas = await this.fetchDataGaji(null, this.tglGaji, true);
    this.gajisDewasSekre = await this.fetchDataGaji(null, this.tglGaji);
    this.gajis = await this.fetchDataGaji([2, 3], this.tglGaji);
    this.gajisDireksi = await this.fetchDataGaji([1], this.tglGaji);
    this.gajisHonor = await this.fetchDataGaji([4], this.tglGaji);
    this.gajisKontrak = await this.fetchDataGaji([5], this.tglGaji);

    this.indexHonor = 0;
  },
  computed: {
    shouldRenderSubBagian() {
      const condition1 = this.subBagians !== null;
      const condition2 = this.subBidangs !== null;
      const condition3 = this.seksis !== null;
      const condition4 = this.jabatans !== null;

      return condition1 && condition2 && condition3 && condition4; //salah satu tidak null
    },
    getGlobalVariable() {
      return indexTableHonor;
    },
    boldStyle() {
      // Define inline styles to make the text bold
      return {
        fontWeight: "bold",
      };
    },
  },

  methods: {
    // incrementTableHonor() {
    //   this.indexTableHonor += 1;
    // },

    incrementIndexTableHonor() {
      indexTableHonor++;
      return indexTableHonor / 2; // This ensures Vue won't interfere with the template rendering
    },
    printGolKontrak(golongan) {
      return golongan ? golongan.charAt(0) : ""; // Return the first character or an empty string if null
    },
    printBulanNama() {
      const date = DateTime.fromFormat(this.tglGaji, "yyyy-M-dd");
      const monthNameIndonesian = date
        .setLocale("id")
        .toFormat("MMMM")
        .toUpperCase();
      return monthNameIndonesian;
    },
    printTahun() {
      return DateTime.fromFormat(this.tglGaji, "yyyy-M-dd").year;
    },

    printRefTdHonor(cabangIndex, index) {
      const refName = "refTdHonor-" + cabangIndex + "-" + index;
      this.$nextTick(() => {
        const tdElement = this.$refs[refName];

        if (tdElement) {
          // Do something with the tdElement
          var temp = this.indexHonor;
          this.indexHonor = temp + 1;
          tdElement[0].textContent = this.indexHonor;
        }
      });
    },

    printRefTdHonorTTD(cabangIndex, index, tambahan = "") {
      const valueRef = "refTdHonor-" + cabangIndex + "-" + index + tambahan; //value
      const ttdRef = "refTdHonorTTD-" + cabangIndex + "-" + index + tambahan; //value
      this.$nextTick(() => {
        const tdElementTtd = this.$refs[ttdRef];

        const tdElementValue = this.$refs[valueRef];

        if (tdElementValue && tdElementTtd) {
          tdElementTtd[0].textContent = tdElementValue[0].textContent;
        }
      });
    },

    printRefTdKontrakTTD(cabangIndex, index, tambahan = "") {
      const valueRef = "refTdKontrak-" + cabangIndex + "-" + index + tambahan; //value
      const ttdRef = "refTdKontrakTTD-" + cabangIndex + "-" + index + tambahan; //value
      this.$nextTick(() => {
        const tdElementTtd = this.$refs[ttdRef];
        const tdElementValue = this.$refs[valueRef];
        if (tdElementValue && tdElementTtd) {
          tdElementTtd[0].textContent = tdElementValue[0].textContent;
        }
      });
    },

    printRefTdKontrak(cabangIndex, index, tambahan = "") {
      const refName = "refTdKontrak-" + cabangIndex + "-" + index + tambahan;
      this.$nextTick(() => {
        const tdElement = this.$refs[refName];

        if (tdElement) {
          // Do something with the tdElement
          var temp = this.indexKontrak;
          this.indexKontrak = temp + 1;
          tdElement[0].textContent = this.indexKontrak;
        }
      });
    },

    // callPrintIndexHonorKontrak(cabangIndex) {
    //   // Use this.$nextTick() to ensure the method is called after rendering
    //   this.$nextTick(() => {
    //     const result = this.printIndexHonorKontrak();
    //     if (!this.printResults[cabangIndex]) {
    //       this.printResults[cabangIndex] = [];
    //     }
    //     this.printResults[cabangIndex].push(result);
    //     // this.printResults[index] = result;
    //     // this.$set(this.printResults, index, result);

    //     return result;
    //   });
    //   // return "hello";
    // },

    // printIndexHonorKontrak() {
    //   var temp1 = this.indexHonor;
    //   var temp2 = temp1 + 1;

    //   this.indexHonor = temp2;
    //   return temp2;
    // },

    printMasaKerjaHonorKontrak(item) {
      //TODO nyari masa kerja bukan dari tgl sekarang, melainkan tgl pembuatan gaji
      const date1 = DateTime.fromISO(item.tgl_gaji);
      const date2 = DateTime.fromISO(item.riwayat_pekerjaan.tgl_mulai_bekerja);
      return Math.floor(date1.diff(date2, "years").years) + " tahun";
    },
    printNewLine(print) {
      if (print)
        return {
          display: "block",
          whiteSpace: "pre-line",
          height: "1em",
        };
      else
        return {
          display: "inline",
        };
    },
    printJabatanHonorKontrak(riwayatPekerjaan) {
      var namaTempat = null,
        title = "";
      if (riwayatPekerjaan.sub_bagian_id !== null) {
        namaTempat = _.find(this.subBagians, {
          id: riwayatPekerjaan.sub_bagian_id,
        });
        title = "Sub Bagian";
      }

      if (riwayatPekerjaan.sub_bidang_id !== null) {
        namaTempat = _.find(this.subBidangs, {
          id: riwayatPekerjaan.sub_bidang_id,
        });
        title = "Sub Bidang";
      }

      if (riwayatPekerjaan.seksi_id !== null) {
        namaTempat = _.find(this.seksis, {
          id: riwayatPekerjaan.seksi_id,
        });

        title = "Seksi";
      }

      if (riwayatPekerjaan.unit_id !== null) {
        namaTempat = _.find(this.units, {
          id: riwayatPekerjaan.unit_id,
        });
        title = "Unit";
      }

      if (namaTempat == null) {
        namaTempat = _.find(this.cabangs, {
          id: riwayatPekerjaan.cabang_id,
        });
        title = "Cabang";
      }

      var jabatan = _.find(this.jabatans, {
        id: riwayatPekerjaan.jabatan_id,
      });

      // return "haha";
      return jabatan.nama + " " + title + " " + namaTempat.nama;
    },
    printSubBagian(print, riwayatPekerjaan) {
      var result = null;
      var text = "";

      if (
        riwayatPekerjaan.bagian_id !== null &&
        riwayatPekerjaan.jabatan_id === 5
      ) {
        result = _.find(this.bagians, {
          id: riwayatPekerjaan.bagian_id,
        });
        text = "BAGIAN " + _.toUpper(result.nama);
        return text;
      }

      if (
        riwayatPekerjaan.cabang_id !== null &&
        riwayatPekerjaan.jabatan_id === 4
      ) {
        result = _.find(this.cabangs, {
          id: riwayatPekerjaan.cabang_id,
        });
        text = "CABANG " + _.toUpper(result.nama);
        return text;
      }

      if (print) {
        if (
          riwayatPekerjaan.bidang_id !== null &&
          riwayatPekerjaan.jabatan_id === 6
        ) {
          result = _.find(this.bagians, {
            id: riwayatPekerjaan.bagian_id,
          });
          text = "BIDANG " + _.toUpper(result.nama);
          return text;
        }

        if (riwayatPekerjaan.sub_bagian_id !== null) {
          result = _.find(this.subBagians, {
            id: riwayatPekerjaan.sub_bagian_id,
          });
          text = "SUB BAG " + _.toUpper(result.nama);
        }
        if (riwayatPekerjaan.sub_bidang_id !== null) {
          result = _.find(this.subBidangs, {
            id: riwayatPekerjaan.sub_bidang_id,
          });
          text = "SUB BIDANG " + _.toUpper(result.nama);
        }
        if (riwayatPekerjaan.seksi_id !== null) {
          result = _.find(this.seksis, {
            id: riwayatPekerjaan.seksi_id,
          });

          text = _.toUpper(result.nama);
        }

        // const result = _.find(this.subBagians, { id: subBagianId });

        if (result) return text;
        return "";

        // return "PRINT SUBBAGIAN/SEKSI";
      }
    },

    convertTglFormat(tgl) {
      const parsedDate = DateTime.fromISO(tgl);

      // Format the date as "namaHari tanggal Bulan tahun" (Indonesian)
      const formattedDate = parsedDate.setLocale("id").toFormat("d MMMM yyyy");
      return formattedDate;
    },

    isDateFormatYMD(dateString) {
      const dateRegex = /^\d{4}-\d{2}-\d{2}$/; // Regular expression for Y-m-d format
      return dateRegex.test(dateString);
    },

    convertTglIndonesia(inputDate) {
      if (!inputDate) return "";
      if (!this.isDateFormatYMD(inputDate)) return "";
      const parsedDate = DateTime.fromISO(inputDate);

      // Format the date in the desired Indonesian format
      const formattedDate = parsedDate.setLocale("id").toLocaleString({
        day: "numeric",
        month: "long",
        year: "numeric",
      });

      return formattedDate;
    },
    async fetchDataGaji(pegawaiStatusId, tglGaji, is_dewas = false) {
      const config = {
        headers: {
          Authorization: api.defaults.headers.common["Authorization"],
          "content-type": "application/json",
        },
      };

      // if (pegawaiStatusId === null) is_dewas = true;

      const data = {
        pegawai_status_ids: pegawaiStatusId,
        tgl_gaji: tglGaji,
        is_dewas: is_dewas,
      };

      try {
        const response = await axios.post(
          // "http://127.0.0.1/api/get_gaji_additional_parameter",
          `${API_BASE_URL}/get_gaji`,
          data,
          config,
        );

        return response.data.data;
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    },

    async fetchDataPejabatPembuatGaji() {
      try {
        const data = {
          tgl_gaji: this.tglGaji,
        };

        const response = await axios.post(
          `${API_BASE_URL}/pejabat_gaji`,
          data,
          {
            headers: {
              Authorization: api.defaults.headers.common["Authorization"],
              "Content-Type": "application/json",
            },
          },
        );
        // this.gaji = response.data.gajis;
        this.pejabatMembuatTgl = this.convertTglIndonesia(
          response.data.tglGaji,
        );

        this.pejabatMengetahui = response.data.kabagUmum.simpeg_pegawai;
        this.pejabatMembuat = response.data.kasubagPersonalia.simpeg_pegawai;
        this.pejabatMenyetujui = response.data.dirum.simpeg_pegawai;
        this.pejabatDirut = response.data.dirut.simpeg_pegawai;

        return response.data;
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    },

    formatNumberTerbilang(value) {
      if (typeof value === "string") {
        value = value.replace(/\./g, "");
      }

      if (value !== null && value !== undefined) {
        // Convert the value to a string and remove the decimal part (".00")
        const stringValue = value.toString().split(".")[0];

        return _.startCase(angkaTerbilang(stringValue));
        // Add thousands separator
        // return stringValue.replace(/\B(?=(\d{3})+(?!\d))/g, ".");
      }
    },
    formatNumber(value) {
      // if (value) {
      //   return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
      // }
      // return value;
      if (value !== null && value !== undefined) {
        // Convert the value to a string and remove the decimal part (".00")
        const stringValue = value.toString().split(".")[0];

        // Add thousands separator
        return stringValue.replace(/\B(?=(\d{3})+(?!\d))/g, ".");
      }
      return value;
    },
    async fetchDataCabang(length = null) {
      try {
        const response = await axios.get(`${API_BASE_URL}/cabang`, {
          headers: {
            Authorization: api.defaults.headers.common["Authorization"],
            "Content-Type": "application/json",
          },
        });
        // this.cabangs = response.data;
        if (length != null) {
          return response.data.length;
        }
        return response.data;
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    },

    async fetchDataUnit() {
      try {
        const response = await axios.get(`${API_BASE_URL}/unit`, {
          headers: {
            Authorization: api.defaults.headers.common["Authorization"],
            "Content-Type": "application/json",
          },
        });
        // this.cabangs = response.data;

        return response.data;
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    },

    async fetchDataBagian() {
      try {
        const response = await axios.get(`${API_BASE_URL}/bagian`, {
          headers: {
            Authorization: api.defaults.headers.common["Authorization"],
            "Content-Type": "application/json",
          },
        });
        // this.bagians = response.data;
        return response.data;
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    },

    toUpper(val) {
      return _.toUpper(val);
    },

    getSumsColJml(conditions, gajiTabel, kontrak = false) {
      var filteredItems = this.getFilteredGajis(conditions, gajiTabel);
      var sum = 0;
      filteredItems.forEach((item) => {
        if (kontrak) {
          sum +=
            parseFloat(item.honor_umk_jml) +
            parseFloat(item.kenaikan_masa_kerja) +
            parseFloat(item.premi_jkk) +
            parseFloat(item.premi_jkm) +
            parseFloat(item.tun_kesehatan) -
            parseFloat(item.pot_5_persen);
        } else {
          var numericValue = parseFloat(item.tun_pph);
          var numericValue2 = parseFloat(item.jml_bruto);

          // Check if the numericValue is a valid number (not NaN)
          if (!isNaN(numericValue)) {
            sum += numericValue + numericValue2;
          }
        }
      });
      return this.formatNumber(sum);
    },

    getSums(conditions, gajiTabel, col) {
      var filteredItems = this.getFilteredGajis(conditions, gajiTabel);
      var sum = 0;
      filteredItems.forEach((item) => {
        var numericValue = parseFloat(item[col]);

        // Check if the numericValue is a valid number (not NaN)
        if (!isNaN(numericValue)) {
          sum += numericValue;
        }
      });

      return this.formatNumber(sum);
    },
    shouldPrintGaji(conditions, gajiTabel) {
      var filteredItems = this.getFilteredGajis(conditions, gajiTabel);

      if (filteredItems.length > 0) return true;
      else return "skip";
    },
    filterGajisByConditions(conditions, groupByCol, gajiTabel) {
      var filteredItems = this.getFilteredGajis(conditions, gajiTabel);
      this.totalRows = filteredItems.length;
      var hasil = filteredItems;

      const sortedData = _.orderBy(
        hasil,
        "riwayat_pekerjaan.jabatan_id",
        "asc",
      );

      if (groupByCol == "") {
        return sortedData;
        // else return "skip";
      }

      // Separate rows with sub_bagian: null, atau tidak dibawah subbagian, sub_bagian pasti 0
      const rowsWithNullSubBagian = _.filter(sortedData, (item) => {
        const condition1 = _.get(item, "riwayat_pekerjaan.jabatan_id") == 4; //cabang
        const condition2 = _.get(item, "riwayat_pekerjaan.jabatan_id") == 5; //bagian
        const condition3 = _.get(item, "riwayat_pekerjaan.jabatan_id") == 6; //bidang
        const condition4 = _.get(item, "riwayat_pekerjaan.jabatan_id") == 9; //unit

        return condition1 || condition2 || condition3 || condition4;
      }); //kabag/kacab/kaunit/kabid

      var dataWithoutNullSubBagian = _.reject(sortedData, (item) => {
        // Define your conditions using logical operators (&&, ||)
        const condition1 = _.get(item, "riwayat_pekerjaan.jabatan_id") == 4; //cabang
        const condition2 = _.get(item, "riwayat_pekerjaan.jabatan_id") == 5; //bagian
        const condition3 = _.get(item, "riwayat_pekerjaan.jabatan_id") == 6; //bidang
        const condition4 = _.get(item, "riwayat_pekerjaan.jabatan_id") == 9; //unit

        return condition1 || condition2 || condition3 || condition4;
      }); //staf/kasubid/kasubag/kaseksi

      const groupByKey = `riwayat_pekerjaan.${groupByCol}`;
      var groupBySubBagianId = null;

      groupBySubBagianId = _.groupBy(dataWithoutNullSubBagian, groupByKey); //group by sub bagian id

      for (const subBagianId in groupBySubBagianId) {
        groupBySubBagianId[subBagianId] = _.orderBy(
          groupBySubBagianId[subBagianId],
          ["riwayat_pekerjaan.jabatan_id", "pegawai.nik"],
          ["asc", "asc"],
        );
        _.forEach(groupBySubBagianId[subBagianId], (value, index, array) => {
          if (index == 0) array[index].print_sub_bagian = true;
          else array[index].print_sub_bagian = false;
        });
      } //order by jabatanid, and then pegawai nik

      var flatGroupBySubBagianId = _.flatten(Object.values(groupBySubBagianId));

      var akhir = _.concat(rowsWithNullSubBagian, flatGroupBySubBagianId); //gabungkan sorted pegawai dengan kabag

      const flattenedData = _.flatten(Object.values(akhir));

      return flattenedData;
    },

    filterGajisByConditions2(conditions, groupByCol, gajiTabel) {
      var filteredItems = this.getFilteredGajis(conditions, gajiTabel);
      this.totalRows = filteredItems.length;
      var hasil = filteredItems;

      const sortedData = _.orderBy(
        hasil,
        "riwayat_pekerjaan.jabatan_id",
        "asc",
      );

      if (groupByCol == "") {
        return sortedData;
        // else return "skip";
      }

      // Separate rows with sub_bagian: null, atau tidak dibawah subbagian, sub_bagian pasti 0
      const rowsWithNullSubBagian = _.filter(sortedData, (item) => {
        const condition1 = _.get(item, "riwayat_pekerjaan.jabatan_id") == 4; //cabang
        const condition2 = _.get(item, "riwayat_pekerjaan.jabatan_id") == 5; //bagian
        const condition3 = _.get(item, "riwayat_pekerjaan.jabatan_id") == 6; //bidang
        const condition4 = _.get(item, "riwayat_pekerjaan.jabatan_id") == 9; //unit

        return condition1 || condition2 || condition3 || condition4;
      }); //kabag/kacab/kaunit/kabid

      const dataWithoutNullSubBagian = _.reject(sortedData, (item) => {
        // Define your conditions using logical operators (&&, ||)
        const condition1 = _.get(item, "riwayat_pekerjaan.jabatan_id") == 4; //cabang
        const condition2 = _.get(item, "riwayat_pekerjaan.jabatan_id") == 5; //bagian
        const condition3 = _.get(item, "riwayat_pekerjaan.jabatan_id") == 6; //bidang
        const condition4 = _.get(item, "riwayat_pekerjaan.jabatan_id") == 9; //unit

        return condition1 || condition2 || condition3 || condition4;
      }); //staf/kasubid/kasubag/kaseksi

      const groupByKey = `riwayat_pekerjaan.${groupByCol}`;
      const groupBySubBagianId = _.groupBy(
        dataWithoutNullSubBagian,
        groupByKey,
      ); //group by sub bagian id

      for (const subBagianId in groupBySubBagianId) {
        groupBySubBagianId[subBagianId] = _.orderBy(
          groupBySubBagianId[subBagianId],
          ["riwayat_pekerjaan.jabatan_id", "pegawai.nik"],
          ["asc", "asc"],
        );
        _.forEach(groupBySubBagianId[subBagianId], (value, index, array) => {
          if (index == 0) array[index].print_sub_bagian = true;
          else array[index].print_sub_bagian = false;
        });
      } //order by jabatanid, and then pegawai nik

      var flatGroupBySubBagianId = _.flatten(Object.values(groupBySubBagianId));

      var akhir = _.concat(rowsWithNullSubBagian, flatGroupBySubBagianId); //gabungkan sorted pegawai dengan kabag

      const flattenedData = _.flatten(Object.values(akhir));
      const sortedDataByGroupCol = _.orderBy(
        flattenedData,
        ["riwayat_pekerjaan." + groupByCol],
        ["asc"],
      ); // or ['desc'] for descending

      return sortedDataByGroupCol;
    },
    getFilteredGajis(conditions, gajiTabel) {
      // return gajiTabel.gajis.filter((item) => {
      return this[gajiTabel].gajis.filter((item) => {
        // Check if all conditions are met
        return conditions.every((condition) => {
          // Initialize a variable to keep track of the current property value
          let currentPropertyValue = item;

          // Use a loop to traverse the nested properties if there are any
          for (const index of condition.indexs) {
            // Check if the current property exists in the object
            if (
              Object.prototype.hasOwnProperty.call(currentPropertyValue, index)
            ) {
              // if (currentPropertyValue.hasOwnProperty(index)) {
              // If the current item has the current property, update currentPropertyValue
              currentPropertyValue = currentPropertyValue[index];
            } else {
              // If the property is not found, return false (don't include in the result)
              return false;
            }
          }

          // Check if the final currentPropertyValue matches the provided value
          return currentPropertyValue === condition.val;
        });
      });
    },

    getPageBreakStyle(index) {
      var rowSaatIni = index + 1;
      if (rowSaatIni > 25 && (rowSaatIni - 1) % 25 === 0) {
        return "top-text table-row-vfor add-page-break-before"; // Add page break before 11th, 21st, etc.
      }
      return "top-text table-row-vfor";
    },

    getPageBreakStyleHonorKontrak(index) {
      // var rowSaatIni = index + 1;
      // if (rowSaatIni === 20)
      //   return "top-text table-row-vfor add-page-break-after"; //page break di tr ke 7
      if (index % 20 === 0)
        return "top-text table-row-vfor add-page-break-before";
      return "top-text table-row-vfor";
    },
  },
};
</script>
